"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Genesis
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.10.12
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FedExETDDocumentTypes = exports.FedExDropOffType = exports.FedExCODRateBasisTypes = exports.FedExCODChargeBasisTypes = exports.FedExCODChargeBasisLevels = exports.FedExBatteryRegulatorySubTypes = exports.FedExBatteryPackagingTypes = exports.FedExBatteryMaterialTypes = exports.FedExAccessorials = exports.DocumentUploadProviderCode = exports.DistanceUnit = exports.DiscountPercentageTableRateTableTypeEnum = exports.DiscountPercentageRowRateTableTypeEnum = exports.DimensionsMeasurementTypeEnum = exports.DeclineShipmentResponseResponseTypeEnum = exports.CustomsOptionsTypes = exports.CustomsBrokerType = exports.CustomerReferenceTypes = exports.CreateUberAccountSchemaProviderCodeEnum = exports.CreateSmc3AccountSchemaProviderCodeEnum = exports.CreateRateMinimumTableRateTableTypeEnum = exports.CreateRateMinimumRowRateTableTypeEnum = exports.CreatePurolatorAccountSchemaProviderCodeEnum = exports.CreateParcelRateRequestTransportationModeEnum = exports.CreateFtlRateRequestTransportationModeEnum = exports.CreateFtlDispatchRequestTransportationModeEnum = exports.CreateDiscountPercentageTableRateTableTypeEnum = exports.CreateDiscountPercentageRowRateTableTypeEnum = exports.CreateCapacityProviderAccountSchemaProviderCodeEnum = exports.CreateCanparAccountSchemaProviderCodeEnum = exports.CreateCHRobinsonAccountSchemaProviderCodeEnum = exports.CreateAmazonAccountSchemaProviderCodeEnum = exports.CountryConstraintConstraintTypeEnum = exports.ContactType = exports.CommercialInvoicePurposeTypes = exports.CommercialInvoiceDocumentUsageType = exports.CodCollectionTypes = exports.CarrierTariffType = exports.CarrierResponse1ResponseTypeEnum = exports.CarrierResponseResponseTypeEnum = exports.CarrierReferenceType = exports.CarrierIdentificationCode = exports.CapacityProviderAccountSchemaProviderCodeEnum = exports.CanparStockTypes = exports.CanparServiceTypes = exports.CanparImageTypes = exports.B13AFilingOptionTypes = exports.AlcoholRecipientTypes = exports.Accessorials = exports.AcceptShipmentResponseResponseTypeEnum = void 0;
exports.ParcelRateTransportationModeEnum = exports.PackagingType = exports.PackageType = exports.PackageSignatureOptionSignatureTypes = exports.NaftaProducerDeterminationCodeTypes = exports.NaftaPreferenceCriterionCodeTypes = exports.NaftaNetCostMethodCodeTypes = exports.MeasurementsMeasurementTypeEnum = exports.LtlRateTransportationModeEnum = exports.LocationType = exports.LinearMeasurementMeasurementTypeEnum = exports.LengthUnit = exports.InternationalDocumentContentTypes = exports.InternationalControlledExportTypes = exports.HazmatPackingGroup = exports.FtlStopReferenceQualifier = exports.FtlStopAccessorials = exports.FtlRateRequestResponseTransportationModeEnum = exports.FtlRateRequestTransportationModeEnum = exports.FtlRateTransportationModeEnum = exports.FtlProductPieceType = exports.FtlPackageType = exports.FtlOrderReferenceType = exports.FtlOrderAccessorial = exports.FtlEquipmentType = exports.FtlDispatchRequestTransportationModeEnum = exports.FreightClass = exports.FedexLabelPrintingOrientations = exports.FedexImageTypes = exports.FedExTaxpayerIDTypes = exports.FedExStockTypes = exports.FedExSmartPostIndiciaTypes = exports.FedExSmartPostCarrierCodes = exports.FedExSmartPostAncillaryEndorsementTypes = exports.FedExShipmentSpecialServices = exports.FedExServiceTypes = exports.FedExReturnTypes = exports.FedExPriorityAlertEnhancementTypes = exports.FedExPickupCarrierCodes = exports.FedExPackageTypes = exports.FedExPackageSpecialServices = exports.FedExPackageAccessorials = exports.FedExNotificationRoleTypes = exports.FedExNotificationEvents = exports.FedExLocationTypes = exports.FedExLabelMaskableDataTypes = exports.FedExHomeDeliveryPremiumTypes = exports.FedExFreightShipmentRoleType = exports.FedExFreightCollectTermTypes = exports.FedExEventNotificationFormat = void 0;
exports.VolumeUnit = exports.UpdateShipmentStateEventTypeEnum = exports.UpdateRateMinimumTableRateTableTypeEnum = exports.UpdateLocationEventTypeEnum = exports.UpdateFtlStopActivityEventTypeEnum = exports.UpdateFtlEquipmentEventTypeEnum = exports.UpdateEtaEventTypeEnum = exports.UpdateDiscountPercentageTableRateTableTypeEnum = exports.UpdateAppointmentEventTypeEnum = exports.UberCapacityProviderAccountSchemaProviderCodeEnum = exports.USPSStockTypes = exports.USPSServiceTypes = exports.USPSPackageTypes = exports.USPSImageTypes = exports.UPSStockTypes = exports.UPSServiceTypes = exports.UPSPackageTypes = exports.UPSImageTypes = exports.TransportationMode = exports.TemperatureUnit = exports.StopReason = exports.StopActivityEventType = exports.SpecialServices = exports.SignatureTypes = exports.ShipmentState = exports.ShipmentMode = exports.RevokeShipmentResponseResponseTypeEnum = exports.ResponseUpdateProviderAccountProvidersProviderCodeAccountIdPutProviderCodeEnum = exports.ResponsePutRateRatesRateRequestIdIdPutTransportationModeEnum = exports.ResponsePostRateRatesRateRequestIdRateIdPostTransportationModeEnum = exports.ResponseGetRateRatesRateRequestIdRateIdGetTransportationModeEnum = exports.ResponseGetRateRateRequestsRateRequestIdRatesRateIdGetTransportationModeEnum = exports.ResponseGetProviderAccountProvidersProviderCodeIdGetProviderCodeEnum = exports.ResponseAddProviderAccountProvidersProviderCodePostProviderCodeEnum = exports.RegulatoryControlTypes = exports.RegionConstraintConstraintTypeEnum = exports.RecipientCustomsIdTypes = exports.RateStatus = exports.RateMinimumTableRateTableTypeEnum = exports.RateMinimumRowRateTableTypeEnum = exports.Rate1TransportationModeEnum = exports.PurolatorStockTypes = exports.PurolatorServiceTypes = exports.PurolatorPackageTypes = exports.PurolatorImageTypes = exports.ProviderCode = exports.PostalCodeConstraintConstraintTypeEnum = exports.PaymentTypes = exports.ParcelStopAccessorials = exports.ParcelRateRequestTransportationModeEnum = void 0;
exports.SMC3Api = exports.SMC3ApiFactory = exports.SMC3ApiFp = exports.SMC3ApiAxiosParamCreator = exports.RatingApi = exports.RatingApiFactory = exports.RatingApiFp = exports.RatingApiAxiosParamCreator = exports.RateTablesApi = exports.RateTablesApiFactory = exports.RateTablesApiFp = exports.RateTablesApiAxiosParamCreator = exports.ProvidersApi = exports.ProvidersApiFactory = exports.ProvidersApiFp = exports.ProvidersApiAxiosParamCreator = exports.PickupsApi = exports.PickupsApiFactory = exports.PickupsApiFp = exports.PickupsApiAxiosParamCreator = exports.FreightAllKindsMappingApi = exports.FreightAllKindsMappingApiFactory = exports.FreightAllKindsMappingApiFp = exports.FreightAllKindsMappingApiAxiosParamCreator = exports.DocumentsApi = exports.DocumentsApiFactory = exports.DocumentsApiFp = exports.DocumentsApiAxiosParamCreator = exports.DispatchApi = exports.DispatchApiFactory = exports.DispatchApiFp = exports.DispatchApiAxiosParamCreator = exports.CarrierTariffEffectiveApi = exports.CarrierTariffEffectiveApiFactory = exports.CarrierTariffEffectiveApiFp = exports.CarrierTariffEffectiveApiAxiosParamCreator = exports.AlternativeApi = exports.AlternativeApiFactory = exports.AlternativeApiFp = exports.AlternativeApiAxiosParamCreator = exports.WeightUnit = exports.WeightQualifier = exports.VolumetricMeasurementMeasurementTypeEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.AcceptShipmentResponseResponseTypeEnum = {
    Accept: 'ACCEPT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.Accessorials = {
    AppointmentDelivery: 'APPOINTMENT_DELIVERY',
    Exhibition: 'EXHIBITION',
    ExcessiveLength: 'EXCESSIVE_LENGTH',
    Guaranteed: 'GUARANTEED',
    HoldAtLocation: 'HOLD_AT_LOCATION',
    InsideDelivery: 'INSIDE_DELIVERY',
    InsidePickup: 'INSIDE_PICKUP',
    LiftgateDelivery: 'LIFTGATE_DELIVERY',
    LiftgatePickup: 'LIFTGATE_PICKUP',
    LimitedAccessDelivery: 'LIMITED_ACCESS_DELIVERY',
    LimitedAccessPickup: 'LIMITED_ACCESS_PICKUP',
    Oversize: 'OVERSIZE',
    OverLength: 'OVER_LENGTH',
    ResidentialDelivery: 'RESIDENTIAL_DELIVERY',
    ResidentialPickup: 'RESIDENTIAL_PICKUP',
    SaturdayDelivery: 'SATURDAY_DELIVERY',
    SaturdayPickup: 'SATURDAY_PICKUP'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.AlcoholRecipientTypes = {
    Consumer: 'CONSUMER',
    Licensee: 'LICENSEE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.B13AFilingOptionTypes = {
    FedexToStamp: 'FEDEX_TO_STAMP',
    FiledElectronically: 'FILED_ELECTRONICALLY',
    ManuallyAttached: 'MANUALLY_ATTACHED',
    NotRequired: 'NOT_REQUIRED',
    SummaryReporting: 'SUMMARY_REPORTING'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CanparImageTypes = {
    Png: 'PNG',
    Pdf: 'PDF',
    Zpl: 'ZPL',
    Epl: 'EPL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CanparServiceTypes = {
    Ground: 'GROUND',
    Usa: 'USA',
    SelectLetter: 'SELECT_LETTER',
    SelectPak: 'SELECT_PAK',
    Select: 'SELECT',
    OvernightLetter: 'OVERNIGHT_LETTER',
    OvernightPak: 'OVERNIGHT_PAK',
    Overnight: 'OVERNIGHT',
    UsaLetter: 'USA_LETTER',
    UsaPak: 'USA_PAK',
    SelectUsa: 'SELECT_USA',
    International: 'INTERNATIONAL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CanparStockTypes = {
    _4x6: '4x6',
    _85x11: '8.5x11'
};
exports.CapacityProviderAccountSchemaProviderCodeEnum = {
    Fedex: 'FEDEX',
    ShipwellFtl: 'SHIPWELL_FTL',
    Ups: 'UPS',
    Usps: 'USPS',
    Any: 'ANY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CarrierIdentificationCode = {
    Scac: 'SCAC',
    Iata: 'IATA'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CarrierReferenceType = {
    Scac: 'SCAC'
};
exports.CarrierResponseResponseTypeEnum = {
    Decline: 'DECLINE'
};
exports.CarrierResponse1ResponseTypeEnum = {
    Decline: 'DECLINE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CarrierTariffType = {
    Interstate: 'INTERSTATE',
    Intrastate: 'INTRASTATE',
    Canada: 'CANADA'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CodCollectionTypes = {
    Any: 'ANY',
    Cash: 'CASH',
    CompanyCheck: 'COMPANY_CHECK',
    GuaranteedFunds: 'GUARANTEED_FUNDS',
    PersonalCheck: 'PERSONAL_CHECK'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CommercialInvoiceDocumentUsageType = {
    LetterHead: 'LETTER_HEAD',
    Signature: 'SIGNATURE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CommercialInvoicePurposeTypes = {
    Gift: 'GIFT',
    NotSold: 'NOT_SOLD',
    PersonalEffects: 'PERSONAL_EFFECTS',
    RepairAndReturn: 'REPAIR_AND_RETURN',
    Sample: 'SAMPLE',
    Sold: 'SOLD'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ContactType = {
    Administrator: 'ADMINISTRATOR',
    AfterHoursContact: 'AFTER_HOURS_CONTACT',
    AppointmentScheduler: 'APPOINTMENT_SCHEDULER',
    Agent: 'AGENT',
    Broker: 'BROKER',
    Other: 'OTHER',
    ForwarderContact: 'FORWARDER_CONTACT',
    ReceivingContact: 'RECEIVING_CONTACT',
    SalesRep: 'SALES_REP',
    ShipperContact: 'SHIPPER_CONTACT',
    UltimateReceiver: 'ULTIMATE_RECEIVER'
};
exports.CountryConstraintConstraintTypeEnum = {
    Country: 'COUNTRY'
};
exports.CreateAmazonAccountSchemaProviderCodeEnum = {
    Amazon: 'AMAZON'
};
exports.CreateCHRobinsonAccountSchemaProviderCodeEnum = {
    Chrobinson: 'CHROBINSON'
};
exports.CreateCanparAccountSchemaProviderCodeEnum = {
    Canpar: 'CANPAR'
};
exports.CreateCapacityProviderAccountSchemaProviderCodeEnum = {
    Fedex: 'FEDEX',
    ShipwellFtl: 'SHIPWELL_FTL',
    Ups: 'UPS',
    Usps: 'USPS',
    Any: 'ANY'
};
exports.CreateDiscountPercentageRowRateTableTypeEnum = {
    DiscountPercentage: 'DISCOUNT_PERCENTAGE'
};
exports.CreateDiscountPercentageTableRateTableTypeEnum = {
    DiscountPercentage: 'DISCOUNT_PERCENTAGE'
};
exports.CreateFtlDispatchRequestTransportationModeEnum = {
    Ftl: 'FTL'
};
exports.CreateFtlRateRequestTransportationModeEnum = {
    Ftl: 'FTL'
};
exports.CreateParcelRateRequestTransportationModeEnum = {
    Parcel: 'PARCEL'
};
exports.CreatePurolatorAccountSchemaProviderCodeEnum = {
    Purolator: 'PUROLATOR'
};
exports.CreateRateMinimumRowRateTableTypeEnum = {
    RateMinimum: 'RATE_MINIMUM'
};
exports.CreateRateMinimumTableRateTableTypeEnum = {
    RateMinimum: 'RATE_MINIMUM'
};
exports.CreateSmc3AccountSchemaProviderCodeEnum = {
    Smc3: 'SMC3'
};
exports.CreateUberAccountSchemaProviderCodeEnum = {
    Uber: 'UBER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CustomerReferenceTypes = {
    CustomerReference: 'CUSTOMER_REFERENCE',
    DepartmentNumber: 'DEPARTMENT_NUMBER',
    IntracountryRegulatoryReference: 'INTRACOUNTRY_REGULATORY_REFERENCE',
    InvoiceNumber: 'INVOICE_NUMBER',
    PONumber: 'P_O_NUMBER',
    RmaAssociation: 'RMA_ASSOCIATION',
    ShipmentIntegrity: 'SHIPMENT_INTEGRITY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CustomsBrokerType = {
    Export: 'EXPORT',
    Import: 'IMPORT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CustomsOptionsTypes = {
    CourtesyReturnLabel: 'COURTESY_RETURN_LABEL',
    ExhibitionTradeShow: 'EXHIBITION_TRADE_SHOW',
    FaultyItem: 'FAULTY_ITEM',
    FollowingRepair: 'FOLLOWING_REPAIR',
    ForRepair: 'FOR_REPAIR',
    ItemForLoan: 'ITEM_FOR_LOAN',
    Other: 'OTHER',
    Rejected: 'REJECTED',
    Replacement: 'REPLACEMENT',
    Trial: 'TRIAL'
};
exports.DeclineShipmentResponseResponseTypeEnum = {
    Decline: 'DECLINE'
};
exports.DimensionsMeasurementTypeEnum = {
    Volume: 'VOLUME'
};
exports.DiscountPercentageRowRateTableTypeEnum = {
    DiscountPercentage: 'DISCOUNT_PERCENTAGE'
};
exports.DiscountPercentageTableRateTableTypeEnum = {
    DiscountPercentage: 'DISCOUNT_PERCENTAGE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DistanceUnit = {
    Mi: 'MI',
    Km: 'KM'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.DocumentUploadProviderCode = {
    Fedex: 'FEDEX',
    Uber: 'UBER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExAccessorials = {
    CallBeforeDelivery: 'CALL_BEFORE_DELIVERY',
    CustomDeliveryWindow: 'CUSTOM_DELIVERY_WINDOW',
    CutFlowers: 'CUT_FLOWERS',
    DoNotBreakDownPallets: 'DO_NOT_BREAK_DOWN_PALLETS',
    EastCoastSpecial: 'EAST_COAST_SPECIAL',
    ElectronicTradeDocuments: 'ELECTRONIC_TRADE_DOCUMENTS',
    ExcludeFromConsolidation: 'EXCLUDE_FROM_CONSOLIDATION',
    FedexOneRate: 'FEDEX_ONE_RATE',
    Food: 'FOOD',
    FreightToCollect: 'FREIGHT_TO_COLLECT',
    PharmacyDelivery: 'PHARMACY_DELIVERY',
    Poison: 'POISON',
    ThirdPartyConsignee: 'THIRD_PARTY_CONSIGNEE',
    TopLoad: 'TOP_LOAD',
    BrokerSelectOption: 'BROKER_SELECT_OPTION'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExBatteryMaterialTypes = {
    Ion: 'LITHIUM_ION',
    Metal: 'LITHIUM_METAL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExBatteryPackagingTypes = {
    ContainedInEquipment: 'CONTAINED_IN_EQUIPMENT',
    PackedWithEquipment: 'PACKED_WITH_EQUIPMENT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExBatteryRegulatorySubTypes = {
    IataSectionIi: 'IATA_SECTION_II'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExCODChargeBasisLevels = {
    CurrentPackage: 'CURRENT_PACKAGE',
    SumOfPackages: 'SUM_OF_PACKAGES'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExCODChargeBasisTypes = {
    CodSurcharge: 'COD_SURCHARGE',
    NetCharge: 'NET_CHARGE',
    NetFreight: 'NET_FREIGHT',
    TotalCustomerCharge: 'TOTAL_CUSTOMER_CHARGE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExCODRateBasisTypes = {
    Account: 'ACCOUNT',
    List: 'LIST'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExDropOffType = {
    RegularPickup: 'REGULAR_PICKUP',
    Station: 'STATION',
    RequestCourier: 'REQUEST_COURIER',
    BusinessServiceCenter: 'BUSINESS_SERVICE_CENTER',
    DropBox: 'DROP_BOX'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExETDDocumentTypes = {
    CertificateOfOrigin: 'CERTIFICATE_OF_ORIGIN',
    CommercialInvoice: 'COMMERCIAL_INVOICE',
    CustomerSpecifiedLabels: 'CUSTOMER_SPECIFIED_LABELS',
    CustomPackageDocument: 'CUSTOM_PACKAGE_DOCUMENT',
    CustomShipmentDocument: 'CUSTOM_SHIPMENT_DOCUMENT',
    DangerousGoodsShippersDeclaration: 'DANGEROUS_GOODS_SHIPPERS_DECLARATION',
    ExportDeclaration: 'EXPORT_DECLARATION',
    FedexFreightStraightBillOfLading: 'FEDEX_FREIGHT_STRAIGHT_BILL_OF_LADING',
    GeneralAgencyAgreement: 'GENERAL_AGENCY_AGREEMENT',
    Label: 'LABEL',
    NaftaCertificateOfOrigin: 'NAFTA_CERTIFICATE_OF_ORIGIN',
    Op900: 'OP_900',
    ProFormaInvoice: 'PRO_FORMA_INVOICE',
    ReturnInstructions: 'RETURN_INSTRUCTIONS',
    VicsBillOfLading: 'VICS_BILL_OF_LADING'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExEventNotificationFormat = {
    Html: 'HTML',
    Text: 'TEXT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExFreightCollectTermTypes = {
    NonRecourseShipperSigned: 'NON_RECOURSE_SHIPPER_SIGNED',
    Standard: 'STANDARD'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExFreightShipmentRoleType = {
    Shipper: 'SHIPPER',
    Consignee: 'CONSIGNEE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExHomeDeliveryPremiumTypes = {
    Appointment: 'APPOINTMENT',
    DateCertain: 'DATE_CERTAIN',
    Evening: 'EVENING'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExLabelMaskableDataTypes = {
    CustomsValue: 'CUSTOMS_VALUE',
    DutiesAndTaxesPayorAccountNumber: 'DUTIES_AND_TAXES_PAYOR_ACCOUNT_NUMBER',
    SecondaryBarcode: 'SECONDARY_BARCODE',
    ShipperAccountNumber: 'SHIPPER_ACCOUNT_NUMBER',
    TermsAndConditions: 'TERMS_AND_CONDITIONS',
    TransportationChargesPayorAccountNumber: 'TRANSPORTATION_CHARGES_PAYOR_ACCOUNT_NUMBER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExLocationTypes = {
    ExpressStation: 'FEDEX_EXPRESS_STATION',
    Facility: 'FEDEX_FACILITY',
    FreightServiceCenter: 'FEDEX_FREIGHT_SERVICE_CENTER',
    GroundTerminal: 'FEDEX_GROUND_TERMINAL',
    HomeDeliveryStation: 'FEDEX_HOME_DELIVERY_STATION',
    Office: 'FEDEX_OFFICE',
    Shipsite: 'FEDEX_SHIPSITE',
    SmartPostHub: 'FEDEX_SMART_POST_HUB',
    AuthorizedShipCenter: 'FEDEX_AUTHORIZED_SHIP_CENTER',
    Onsite: 'FEDEX_ONSITE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExNotificationEvents = {
    Delivery: 'ON_DELIVERY',
    EstimatedDelivery: 'ON_ESTIMATED_DELIVERY',
    Exception: 'ON_EXCEPTION',
    PickupDriverArrived: 'ON_PICKUP_DRIVER_ARRIVED',
    PickupDriverAssigned: 'ON_PICKUP_DRIVER_ASSIGNED',
    PickupDriverDeparted: 'ON_PICKUP_DRIVER_DEPARTED',
    PickupDriverEnRoute: 'ON_PICKUP_DRIVER_EN_ROUTE',
    Shipment: 'ON_SHIPMENT',
    Tender: 'ON_TENDER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExNotificationRoleTypes = {
    Broker: 'BROKER',
    Other: 'OTHER',
    Recipient: 'RECIPIENT',
    Shipper: 'SHIPPER',
    ThirdParty: 'THIRD_PARTY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExPackageAccessorials = {
    AppointmentDelivery: 'APPOINTMENT_DELIVERY',
    NonStandardContainer: 'NON_STANDARD_CONTAINER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExPackageSpecialServices = {
    Battery: 'BATTERY',
    PriorityAlert: 'PRIORITY_ALERT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExPackageTypes = {
    Fedex10KgBox: 'FEDEX_10KG_BOX',
    Fedex25KgBox: 'FEDEX_25KG_BOX',
    FedexBox: 'FEDEX_BOX',
    FedexEnvelope: 'FEDEX_ENVELOPE',
    FedexExtraLargeBox: 'FEDEX_EXTRA_LARGE_BOX',
    FedexLargeBox: 'FEDEX_LARGE_BOX',
    FedexMediumBox: 'FEDEX_MEDIUM_BOX',
    FedexPak: 'FEDEX_PAK',
    FedexSmallBox: 'FEDEX_SMALL_BOX',
    FedexTube: 'FEDEX_TUBE',
    YourPackaging: 'YOUR_PACKAGING'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExPickupCarrierCodes = {
    Fdxg: 'FDXG',
    Fdxe: 'FDXE',
    Fxsp: 'FXSP'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExPriorityAlertEnhancementTypes = {
    PriorityAlertPlus: 'PRIORITY_ALERT_PLUS'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExReturnTypes = {
    FedexTag: 'FEDEX_TAG',
    Pending: 'PENDING',
    PrintReturnLabel: 'PRINT_RETURN_LABEL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExServiceTypes = {
    Fedex1DayFreight: 'FEDEX_1_DAY_FREIGHT',
    Fedex2Day: 'FEDEX_2_DAY',
    Fedex2DayAm: 'FEDEX_2_DAY_AM',
    Fedex2DayFreight: 'FEDEX_2_DAY_FREIGHT',
    Fedex3DayFreight: 'FEDEX_3_DAY_FREIGHT',
    FedexExpressSaver: 'FEDEX_EXPRESS_SAVER',
    FedexFirstFreight: 'FEDEX_FIRST_FREIGHT',
    FedexFreightEconomy: 'FEDEX_FREIGHT_ECONOMY',
    FedexFreightPriority: 'FEDEX_FREIGHT_PRIORITY',
    FedexGround: 'FEDEX_GROUND',
    FirstOvernight: 'FIRST_OVERNIGHT',
    GroundHomeDelivery: 'GROUND_HOME_DELIVERY',
    InternationalEconomy: 'INTERNATIONAL_ECONOMY',
    InternationalEconomyFreight: 'INTERNATIONAL_ECONOMY_FREIGHT',
    InternationalFirst: 'INTERNATIONAL_FIRST',
    InternationalPriority: 'INTERNATIONAL_PRIORITY',
    FedexInternationalPriority: 'FEDEX_INTERNATIONAL_PRIORITY',
    InternationalPriorityExpress: 'INTERNATIONAL_PRIORITY_EXPRESS',
    FedexInternationalPriorityExpress: 'FEDEX_INTERNATIONAL_PRIORITY_EXPRESS',
    InternationalPriorityFreight: 'INTERNATIONAL_PRIORITY_FREIGHT',
    PriorityOvernight: 'PRIORITY_OVERNIGHT',
    SmartPost: 'SMART_POST',
    StandardOvernight: 'STANDARD_OVERNIGHT',
    EuropeFirstInternationalPriority: 'EUROPE_FIRST_INTERNATIONAL_PRIORITY',
    FedexDistanceDeferred: 'FEDEX_DISTANCE_DEFERRED',
    FedexNextDayAfternoon: 'FEDEX_NEXT_DAY_AFTERNOON',
    FedexNextDayEarlyMorning: 'FEDEX_NEXT_DAY_EARLY_MORNING',
    FedexNextDayEndOfDay: 'FEDEX_NEXT_DAY_END_OF_DAY',
    FedexNextDayFreight: 'FEDEX_NEXT_DAY_FREIGHT',
    FedexNextDayMidMorning: 'FEDEX_NEXT_DAY_MID_MORNING',
    SameDay: 'SAME_DAY',
    SameDayCity: 'SAME_DAY_CITY',
    FedexStandardOvernightExtraHours: 'FEDEX_STANDARD_OVERNIGHT_EXTRA_HOURS',
    FedexPriorityOvernightExtraHours: 'FEDEX_PRIORITY_OVERNIGHT_EXTRA_HOURS',
    FedexFirstOvernightExtraHours: 'FEDEX_FIRST_OVERNIGHT_EXTRA_HOURS',
    FedexInternationalConnectPlus: 'FEDEX_INTERNATIONAL_CONNECT_PLUS'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExShipmentSpecialServices = {
    HoldAtLocation: 'HOLD_AT_LOCATION',
    EventNotification: 'EVENT_NOTIFICATION',
    HomeDeliveryPremium: 'HOME_DELIVERY_PREMIUM',
    InternationalControlledExportService: 'INTERNATIONAL_CONTROLLED_EXPORT_SERVICE',
    ReturnShipment: 'RETURN_SHIPMENT',
    ReturnsClearance: 'RETURNS_CLEARANCE',
    ElectronicTradeDocuments: 'ELECTRONIC_TRADE_DOCUMENTS'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExSmartPostAncillaryEndorsementTypes = {
    AddressCorrection: 'ADDRESS_CORRECTION',
    CarrierLeaveIfNoResponse: 'CARRIER_LEAVE_IF_NO_RESPONSE',
    ChangeService: 'CHANGE_SERVICE',
    ForwardingService: 'FORWARDING_SERVICE',
    ReturnService: 'RETURN_SERVICE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExSmartPostCarrierCodes = {
    Fdxg: 'FDXG',
    Fxsp: 'FXSP'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExSmartPostIndiciaTypes = {
    MediaMail: 'MEDIA_MAIL',
    ParcelReturn: 'PARCEL_RETURN',
    ParcelSelect: 'PARCEL_SELECT',
    PresortedBoundPrintedMatter: 'PRESORTED_BOUND_PRINTED_MATTER',
    PresortedStandard: 'PRESORTED_STANDARD'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExStockTypes = {
    Paper4X6: 'PAPER_4X6',
    Paper4X675: 'PAPER_4X6.75',
    Paper4X8: 'PAPER_4X8',
    Paper4X9: 'PAPER_4X9',
    Paper7X475: 'PAPER_7X4.75',
    Paper85X11BottomHalfLabel: 'PAPER_8.5X11_BOTTOM_HALF_LABEL',
    Paper85X11TopHalfLabel: 'PAPER_8.5X11_TOP_HALF_LABEL',
    Stock4X6: 'STOCK_4X6',
    Stock4X675LeadingDocTab: 'STOCK_4X6.75_LEADING_DOC_TAB',
    Stock4X675TrailingDocTab: 'STOCK_4X6.75_TRAILING_DOC_TAB',
    Stock4X8: 'STOCK_4X8',
    Stock4X9: 'STOCK_4X9',
    Stock4X9LeadingDocTab: 'STOCK_4X9_LEADING_DOC_TAB',
    Stock4X9TrailingDocTab: 'STOCK_4X9_TRAILING_DOC_TAB'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedExTaxpayerIDTypes = {
    BusinessNational: 'BUSINESS_NATIONAL',
    BusinessState: 'BUSINESS_STATE',
    BusinessUnion: 'BUSINESS_UNION',
    PersonalNational: 'PERSONAL_NATIONAL',
    PersonalState: 'PERSONAL_STATE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedexImageTypes = {
    Epl2: 'EPL2',
    Pdf: 'PDF',
    Zplii: 'ZPLII'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FedexLabelPrintingOrientations = {
    TopEdgeOfTextFirst: 'TOP_EDGE_OF_TEXT_FIRST',
    BottomEdgeOfTextFirst: 'BOTTOM_EDGE_OF_TEXT_FIRST'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FreightClass = {
    _50: '50',
    _55: '55',
    _60: '60',
    _65: '65',
    _70: '70',
    _775: '77.5',
    _85: '85',
    _925: '92.5',
    _100: '100',
    _110: '110',
    _125: '125',
    _150: '150',
    _175: '175',
    _200: '200',
    _250: '250',
    _300: '300',
    _400: '400',
    _500: '500'
};
exports.FtlDispatchRequestTransportationModeEnum = {
    Ftl: 'FTL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FtlEquipmentType = {
    DryVan: 'DRY_VAN',
    Reefer: 'REEFER',
    Flatbed: 'FLATBED',
    Container: 'CONTAINER',
    Autohauler: 'AUTOHAULER',
    Bulk: 'BULK',
    Tanker: 'TANKER',
    CurtainSide: 'CURTAIN_SIDE',
    Hopper: 'HOPPER',
    DropDeck: 'DROP_DECK',
    Tilt: 'TILT',
    ContainerInsulated: 'CONTAINER_INSULATED',
    Conestoga: 'CONESTOGA',
    FlatbedConestoga: 'FLATBED_CONESTOGA',
    StepdeckConestoga: 'STEPDECK_CONESTOGA',
    ContainerRefrigerated: 'CONTAINER_REFRIGERATED',
    BTrain: 'B_TRAIN',
    DoubleDrop: 'DOUBLE_DROP',
    DropDeckLandoll: 'DROP_DECK_LANDOLL',
    DumpTrailer: 'DUMP_TRAILER',
    FlatbedHotshot: 'FLATBED_HOTSHOT',
    FlatbedMaxi: 'FLATBED_MAXI',
    Lowboy: 'LOWBOY',
    LowboyOverdimension: 'LOWBOY_OVERDIMENSION',
    RemovableGooseneck: 'REMOVABLE_GOOSENECK',
    StretchTrailer: 'STRETCH_TRAILER',
    TruckAndTrailer: 'TRUCK_AND_TRAILER',
    StepDeck: 'STEP_DECK',
    HopperBottom: 'HOPPER_BOTTOM',
    Pneumatic: 'PNEUMATIC',
    Flatbed53Foot: 'FLATBED_53_FOOT',
    FlatbedAirRide: 'FLATBED_AIR_RIDE',
    FlatbedDouble: 'FLATBED_DOUBLE',
    FlatbedOverdimension: 'FLATBED_OVERDIMENSION',
    AutoCarrier: 'AUTO_CARRIER',
    Conveyor: 'CONVEYOR',
    PowerOnly: 'POWER_ONLY',
    StraightBoxTruck: 'STRAIGHT_BOX_TRUCK',
    InsulatedVan: 'INSULATED_VAN',
    ReeferAirRide: 'REEFER_AIR_RIDE',
    ReeferDouble: 'REEFER_DOUBLE',
    ReeferIntermodal: 'REEFER_INTERMODAL',
    TankerAluminum: 'TANKER_ALUMINUM',
    TankerIntermodal: 'TANKER_INTERMODAL',
    TankerSteel: 'TANKER_STEEL',
    MovingVan: 'MOVING_VAN',
    VanDouble: 'VAN_DOUBLE',
    VanInsulated: 'VAN_INSULATED',
    VanIntermodal: 'VAN_INTERMODAL',
    VanOpenTop: 'VAN_OPEN_TOP',
    VanRollerBed: 'VAN_ROLLER_BED',
    VanTriple: 'VAN_TRIPLE',
    VanVented: 'VAN_VENTED',
    VanWithCurtains: 'VAN_WITH_CURTAINS',
    VanAirRide: 'VAN_AIR_RIDE',
    VanSprinter: 'VAN_SPRINTER',
    ContainerBreakBulk: 'CONTAINER_BREAK_BULK',
    ContainerFlatTrack20Foot: 'CONTAINER_FLAT_TRACK_20_FOOT',
    ContainerFlatTrack40Foot: 'CONTAINER_FLAT_TRACK_40_FOOT',
    ContainerHeavyTested20Foot: 'CONTAINER_HEAVY_TESTED_20_FOOT',
    ContainerHighCube40Foot: 'CONTAINER_HIGH_CUBE_40_FOOT',
    ContainerOpenTop20Foot: 'CONTAINER_OPEN_TOP_20_FOOT',
    ContainerOpenTop40Foot: 'CONTAINER_OPEN_TOP_40_FOOT',
    ContainerReefer20Foot: 'CONTAINER_REEFER_20_FOOT',
    ContainerReefer40Foot: 'CONTAINER_REEFER_40_FOOT',
    ContainerStandard20Foot: 'CONTAINER_STANDARD_20_FOOT',
    ContainerStandard40Foot: 'CONTAINER_STANDARD_40_FOOT',
    ContainerHighCube45Foot: 'CONTAINER_HIGH_CUBE_45_FOOT',
    ContainerIsoTank20Foot: 'CONTAINER_ISO_TANK_20_FOOT',
    ContainerIsoTank24Foot: 'CONTAINER_ISO_TANK_24_FOOT',
    ContainerIsoTank40Foot: 'CONTAINER_ISO_TANK_40_FOOT',
    Container53Foot: 'CONTAINER_53_FOOT',
    ContainerOversize: 'CONTAINER_OVERSIZE',
    MultiCompartment: 'MULTI_COMPARTMENT',
    ContainerReeferTank20Foot: 'CONTAINER_REEFER_TANK_20_FOOT',
    ContainerHighCube20Foot: 'CONTAINER_HIGH_CUBE_20_FOOT',
    LiquidBulkTanker: 'LIQUID_BULK_TANKER',
    DryBulkTanker: 'DRY_BULK_TANKER',
    CargoVan: 'CARGO_VAN',
    MiniVan: 'MINI_VAN',
    Sedan: 'SEDAN',
    TboxRailcar: 'TBOX_RAILCAR',
    CryoRailcar: 'CRYO_RAILCAR',
    Driveaway: 'DRIVEAWAY',
    CustomerPickup: 'CUSTOMER_PICKUP',
    DropTrailer: 'DROP_TRAILER',
    AutoRackBiLevel: 'AUTO_RACK_BI_LEVEL',
    AutoRackTriLevel: 'AUTO_RACK_TRI_LEVEL',
    AutoMax: 'AUTO_MAX',
    Boxcar: 'BOXCAR',
    BulkheadFlatcar: 'BULKHEAD_FLATCAR',
    CenterbeamFlatcar: 'CENTERBEAM_FLATCAR',
    ChainTieDownFlatcar: 'CHAIN_TIE_DOWN_FLATCAR',
    CoalCar: 'COAL_CAR',
    CoilSteelRailcar: 'COIL_STEEL_RAILCAR',
    CoveredCoilRailcar: 'COVERED_COIL_RAILCAR',
    CoveredHopper: 'COVERED_HOPPER',
    Gondola: 'GONDOLA',
    OpenTopHopper: 'OPEN_TOP_HOPPER',
    PipeFlatcar: 'PIPE_FLATCAR',
    RefrigeratedBoxcar: 'REFRIGERATED_BOXCAR',
    TempControlledTrailer: 'TEMP_CONTROLLED_TRAILER',
    Trailer: 'TRAILER',
    HalfTonTruck: 'HALF_TON_TRUCK',
    OneTonTruck: 'ONE_TON_TRUCK',
    MiniFloatTrailerAndTruck: 'MINI_FLOAT_TRAILER_AND_TRUCK',
    Towing: 'TOWING',
    Conestoga48: 'CONESTOGA_48',
    Conestoga53: 'CONESTOGA_53',
    FlatbedConestoga48: 'FLATBED_CONESTOGA_48',
    FlatbedConestoga53: 'FLATBED_CONESTOGA_53',
    StepdeckConestoga48: 'STEPDECK_CONESTOGA_48',
    StepdeckConestoga53: 'STEPDECK_CONESTOGA_53',
    CoFlatbed: 'CO_FLATBED',
    CoStakeBed: 'CO_STAKE_BED',
    Tiltbed48Wench: 'TILTBED_48_WENCH',
    WreckerTiltbed: 'WRECKER_TILTBED',
    FourAxleHeavyHaulTrailer: 'FOUR_AXLE_HEAVY_HAUL_TRAILER',
    Other: 'OTHER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FtlOrderAccessorial = {
    Guaranteed: 'GUARANTEED'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FtlOrderReferenceType = {
    BolNumber: 'BOL_NUMBER',
    ProNumber: 'PRO_NUMBER',
    PoNumber: 'PO_NUMBER',
    ShipmentRefNumber: 'SHIPMENT_REF_NUMBER',
    PickupNumber: 'PICKUP_NUMBER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FtlPackageType = {
    Bag: 'BAG',
    Bale: 'BALE',
    Barrel: 'BARREL',
    Basket: 'BASKET',
    Bottle: 'BOTTLE',
    Box: 'BOX',
    Bucket: 'BUCKET',
    Bundle: 'BUNDLE',
    Carton: 'CARTON',
    Case: 'CASE',
    Coil: 'COIL',
    Container: 'CONTAINER',
    Crate: 'CRATE',
    Cylinder: 'CYLINDER',
    Drum: 'DRUM',
    Hamper: 'HAMPER',
    Jerrican: 'JERRICAN',
    Other: 'OTHER',
    Pail: 'PAIL',
    Pallet: 'PALLET',
    Piece: 'PIECE',
    Reel: 'REEL',
    Roll: 'ROLL',
    Skid: 'SKID',
    Tank: 'TANK',
    Tube: 'TUBE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FtlProductPieceType = {
    Bag: 'BAG',
    Bale: 'BALE',
    Bottle: 'BOTTLE',
    Box: 'BOX',
    Bucket: 'BUCKET',
    Bundle: 'BUNDLE',
    Can: 'CAN',
    Carton: 'CARTON',
    Case: 'CASE',
    Coil: 'COIL',
    Crate: 'CRATE',
    Cylinder: 'CYLINDER',
    Drum: 'DRUM',
    Jerrican: 'JERRICAN',
    Pail: 'PAIL',
    Pieces: 'PIECES',
    Reel: 'REEL',
    Roll: 'ROLL',
    Skid: 'SKID',
    Tube: 'TUBE'
};
exports.FtlRateTransportationModeEnum = {
    Ftl: 'FTL'
};
exports.FtlRateRequestTransportationModeEnum = {
    Ftl: 'FTL'
};
exports.FtlRateRequestResponseTransportationModeEnum = {
    Ftl: 'FTL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FtlStopAccessorials = {
    ResidentialPickup: 'RESIDENTIAL_PICKUP',
    ResidentialDelivery: 'RESIDENTIAL_DELIVERY',
    SaturdayDelivery: 'SATURDAY_DELIVERY',
    AppointmentDelivery: 'APPOINTMENT_DELIVERY',
    LimitedAccessDelivery: 'LIMITED_ACCESS_DELIVERY',
    LimitedAccessPickup: 'LIMITED_ACCESS_PICKUP',
    SaturdayPickup: 'SATURDAY_PICKUP',
    PickupAppointment: 'PICKUP_APPOINTMENT',
    DropTrailerDelivery: 'DROP_TRAILER_DELIVERY',
    InsidePickup: 'INSIDE_PICKUP',
    InsideDelivery: 'INSIDE_DELIVERY',
    LiftgateDelivery: 'LIFTGATE_DELIVERY',
    LiftgatePickup: 'LIFTGATE_PICKUP',
    ConventionTradeshowDelivery: 'CONVENTION_TRADESHOW_DELIVERY',
    ConventionTradeshowPickup: 'CONVENTION_TRADESHOW_PICKUP',
    ConstructionSitePickup: 'CONSTRUCTION_SITE_PICKUP',
    ConstructionSiteDelivery: 'CONSTRUCTION_SITE_DELIVERY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.FtlStopReferenceQualifier = {
    PickupNumber: 'PICKUP_NUMBER',
    BolNumber: 'BOL_NUMBER',
    ProNumber: 'PRO_NUMBER',
    PoNumber: 'PO_NUMBER',
    ShipmentRefNumber: 'SHIPMENT_REF_NUMBER'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.HazmatPackingGroup = {
    Default: 'DEFAULT',
    I: 'I',
    Ii: 'II',
    Iii: 'III'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.InternationalControlledExportTypes = {
    Dea036: 'DEA_036',
    Dea236: 'DEA_236',
    Dea486: 'DEA_486',
    Dsp05: 'DSP_05',
    Dsp61: 'DSP_61',
    Dsp73: 'DSP_73',
    Dsp85: 'DSP_85',
    Dsp94: 'DSP_94',
    DspLicenseAgreement: 'DSP_LICENSE_AGREEMENT',
    FromForeignTradeZone: 'FROM_FOREIGN_TRADE_ZONE',
    WarehouseWithdrawal: 'WAREHOUSE_WITHDRAWAL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.InternationalDocumentContentTypes = {
    Derived: 'DERIVED',
    DocumentsOnly: 'DOCUMENTS_ONLY',
    NonDocuments: 'NON_DOCUMENTS'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.LengthUnit = {
    Cm: 'CM',
    Ft: 'FT',
    In: 'IN',
    M: 'M'
};
exports.LinearMeasurementMeasurementTypeEnum = {
    Dimensions: 'DIMENSIONS'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.LocationType = {
    Exhibition: 'EXHIBITION',
    BusinessWithDock: 'BUSINESS_WITH_DOCK',
    Other: 'OTHER'
};
exports.LtlRateTransportationModeEnum = {
    Ltl: 'LTL'
};
exports.MeasurementsMeasurementTypeEnum = {
    Volume: 'VOLUME'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.NaftaNetCostMethodCodeTypes = {
    Nc: 'NC',
    No: 'NO'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.NaftaPreferenceCriterionCodeTypes = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    F: 'F'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.NaftaProducerDeterminationCodeTypes = {
    No1: 'NO_1',
    No2: 'NO_2',
    No3: 'NO_3',
    Yes: 'YES'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.PackageSignatureOptionSignatureTypes = {
    AdultSignature: 'ADULT_SIGNATURE',
    DirectSignature: 'DIRECT_SIGNATURE',
    NoSignature: 'NO_SIGNATURE',
    IndirectSignature: 'INDIRECT_SIGNATURE',
    ServiceDefault: 'SERVICE_DEFAULT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.PackageType = {
    Bag: 'BAG',
    Bale: 'BALE',
    Barrel: 'BARREL',
    Basket: 'BASKET',
    Bottle: 'BOTTLE',
    Box: 'BOX',
    Bucket: 'BUCKET',
    Bundle: 'BUNDLE',
    Carton: 'CARTON',
    Case: 'CASE',
    Coil: 'COIL',
    Container: 'CONTAINER',
    Crate: 'CRATE',
    Cylinder: 'CYLINDER',
    Drum: 'DRUM',
    Envelope: 'ENVELOPE',
    Hamper: 'HAMPER',
    Jerrican: 'JERRICAN',
    Other: 'OTHER',
    Pail: 'PAIL',
    Pallet: 'PALLET',
    Piece: 'PIECE',
    Reel: 'REEL',
    Roll: 'ROLL',
    Skid: 'SKID',
    Tank: 'TANK',
    Tube: 'TUBE',
    Can: 'CAN',
    Cylind: 'CYLIND',
    Pieces: 'PIECES',
    Plt: 'PLT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.PackagingType = {
    Bag: 'BAG',
    Bale: 'BALE',
    Barrel: 'BARREL',
    Basket: 'BASKET',
    Bin: 'BIN',
    Bottle: 'BOTTLE',
    Box: 'BOX',
    Bucket: 'BUCKET',
    Bundle: 'BUNDLE',
    Can: 'CAN',
    Carton: 'CARTON',
    Case: 'CASE',
    Coil: 'COIL',
    Container: 'CONTAINER',
    Crate: 'CRATE',
    Cylinder: 'CYLINDER',
    Drum: 'DRUM',
    Envelope: 'ENVELOPE',
    FloorLoaded: 'FLOOR_LOADED',
    Hamper: 'HAMPER',
    Jerrican: 'JERRICAN',
    None: 'NONE',
    Other: 'OTHER',
    Package: 'PACKAGE',
    Pail: 'PAIL',
    Pallet: 'PALLET',
    Piece: 'PIECE',
    ProviderSpecific: 'PROVIDER_SPECIFIC',
    Reel: 'REEL',
    Roll: 'ROLL',
    Skid: 'SKID',
    Tank: 'TANK',
    ToteBin: 'TOTE_BIN',
    ToteCan: 'TOTE_CAN',
    Tube: 'TUBE',
    Unit: 'UNIT'
};
exports.ParcelRateTransportationModeEnum = {
    Parcel: 'PARCEL'
};
exports.ParcelRateRequestTransportationModeEnum = {
    Parcel: 'PARCEL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ParcelStopAccessorials = {
    AppointmentDelivery: 'APPOINTMENT_DELIVERY',
    InsideDelivery: 'INSIDE_DELIVERY',
    InsidePickup: 'INSIDE_PICKUP',
    LimitedAccessDelivery: 'LIMITED_ACCESS_DELIVERY',
    LimitedAccessPickup: 'LIMITED_ACCESS_PICKUP',
    SaturdayDelivery: 'SATURDAY_DELIVERY',
    SaturdayPickup: 'SATURDAY_PICKUP'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.PaymentTypes = {
    Recipient: 'RECIPIENT',
    Sender: 'SENDER',
    ThirdParty: 'THIRD_PARTY',
    Collect: 'COLLECT'
};
exports.PostalCodeConstraintConstraintTypeEnum = {
    PostalCode: 'POSTAL_CODE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ProviderCode = {
    Amazon: 'AMAZON',
    Chrobinson: 'CHROBINSON',
    Smc3: 'SMC3',
    Uber: 'UBER',
    Fedex: 'FEDEX',
    ShipwellFtl: 'SHIPWELL_FTL',
    Ups: 'UPS',
    Usps: 'USPS',
    Purolator: 'PUROLATOR',
    Canpar: 'CANPAR',
    Any: 'ANY'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.PurolatorImageTypes = {
    Png: 'PNG',
    Pdf: 'PDF',
    Zpl: 'ZPL',
    Epl: 'EPL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.PurolatorPackageTypes = {
    CustomerPackaging: 'PUROLATOR_CUSTOMER_PACKAGING',
    ExpressPack: 'PUROLATOR_EXPRESS_PACK',
    ExpressBox: 'PUROLATOR_EXPRESS_BOX',
    ExpressEnvelope: 'PUROLATOR_EXPRESS_ENVELOPE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.PurolatorServiceTypes = {
    Express: 'PUROLATOR_EXPRESS',
    Express12Pm: 'PUROLATOR_EXPRESS_12PM',
    ExpressPack12Pm: 'PUROLATOR_EXPRESS_PACK_12PM',
    ExpressBox12Pm: 'PUROLATOR_EXPRESS_BOX_12PM',
    ExpressEnvelope12Pm: 'PUROLATOR_EXPRESS_ENVELOPE_12PM',
    Express1030Am: 'PUROLATOR_EXPRESS_1030AM',
    Express9Am: 'PUROLATOR_EXPRESS_9AM',
    ExpressBox: 'PUROLATOR_EXPRESS_BOX',
    ExpressBox1030Am: 'PUROLATOR_EXPRESS_BOX_1030AM',
    ExpressBox9Am: 'PUROLATOR_EXPRESS_BOX_9AM',
    ExpressBoxEvening: 'PUROLATOR_EXPRESS_BOX_EVENING',
    ExpressBoxInternational: 'PUROLATOR_EXPRESS_BOX_INTERNATIONAL',
    ExpressBoxUs: 'PUROLATOR_EXPRESS_BOX_US',
    ExpressEnvelope: 'PUROLATOR_EXPRESS_ENVELOPE',
    ExpressEnvelope1030Am: 'PUROLATOR_EXPRESS_ENVELOPE_1030AM',
    ExpressEnvelope9Am: 'PUROLATOR_EXPRESS_ENVELOPE_9AM',
    ExpressEnvelopeEvening: 'PUROLATOR_EXPRESS_ENVELOPE_EVENING',
    ExpressEnvelopeInternational: 'PUROLATOR_EXPRESS_ENVELOPE_INTERNATIONAL',
    ExpressEnvelopeUs: 'PUROLATOR_EXPRESS_ENVELOPE_US',
    ExpressEvening: 'PUROLATOR_EXPRESS_EVENING',
    ExpressInternational: 'PUROLATOR_EXPRESS_INTERNATIONAL',
    ExpressInternational1030Am: 'PUROLATOR_EXPRESS_INTERNATIONAL_1030AM',
    ExpressInternational1200: 'PUROLATOR_EXPRESS_INTERNATIONAL_1200',
    ExpressInternational9Am: 'PUROLATOR_EXPRESS_INTERNATIONAL_9AM',
    ExpressBoxInternational1030Am: 'PUROLATOR_EXPRESS_BOX_INTERNATIONAL_1030AM',
    ExpressBoxInternational1200: 'PUROLATOR_EXPRESS_BOX_INTERNATIONAL_1200',
    ExpressBoxInternational9Am: 'PUROLATOR_EXPRESS_BOX_INTERNATIONAL_9AM',
    ExpressEnvelopeInternational1030Am: 'PUROLATOR_EXPRESS_ENVELOPE_INTERNATIONAL_1030AM',
    ExpressEnvelopeInternational1200: 'PUROLATOR_EXPRESS_ENVELOPE_INTERNATIONAL_1200',
    ExpressEnvelopeInternational9Am: 'PUROLATOR_EXPRESS_ENVELOPE_INTERNATIONAL_9AM',
    ExpressPackInternational1030Am: 'PUROLATOR_EXPRESS_PACK_INTERNATIONAL_1030AM',
    ExpressPackInternational1200: 'PUROLATOR_EXPRESS_PACK_INTERNATIONAL_1200',
    ExpressPackInternational9Am: 'PUROLATOR_EXPRESS_PACK_INTERNATIONAL_9AM',
    ExpressPack: 'PUROLATOR_EXPRESS_PACK',
    ExpressPack1030Am: 'PUROLATOR_EXPRESS_PACK_1030AM',
    ExpressPack9Am: 'PUROLATOR_EXPRESS_PACK_9AM',
    ExpressPackEvening: 'PUROLATOR_EXPRESS_PACK_EVENING',
    ExpressPackInternational: 'PUROLATOR_EXPRESS_PACK_INTERNATIONAL',
    ExpressPackUs: 'PUROLATOR_EXPRESS_PACK_US',
    ExpressUs: 'PUROLATOR_EXPRESS_US',
    ExpressUs1030Am: 'PUROLATOR_EXPRESS_US_1030AM',
    ExpressUs1200: 'PUROLATOR_EXPRESS_US_1200',
    ExpressUs9Am: 'PUROLATOR_EXPRESS_US_9AM',
    ExpressBoxUs1030Am: 'PUROLATOR_EXPRESS_BOX_US_1030AM',
    ExpressBoxUs1200: 'PUROLATOR_EXPRESS_BOX_US_1200',
    ExpressBoxUs9Am: 'PUROLATOR_EXPRESS_BOX_US_9_AM',
    ExpressEnvelopeUs1030Am: 'PUROLATOR_EXPRESS_ENVELOPE_US_1030AM',
    ExpressEnvelopeUs1200: 'PUROLATOR_EXPRESS_ENVELOPE_US_1200',
    ExpressEnvelopeUs9Am: 'PUROLATOR_EXPRESS_ENVELOPE_US_9AM',
    ExpressPackUs1030Am: 'PUROLATOR_EXPRESS_PACK_US_1030AM',
    ExpressPackUs1200: 'PUROLATOR_EXPRESS_PACK_US_1200',
    ExpressPackUs9Am: 'PUROLATOR_EXPRESS_PACK_US_9AM',
    Ground: 'PUROLATOR_GROUND',
    Ground1030Am: 'PUROLATOR_GROUND_1030AM',
    Ground9Am: 'PUROLATOR_GROUND_9AM',
    Ground12Pm: 'PUROLATOR_GROUND_12PM',
    GroundDistribution: 'PUROLATOR_GROUND_DISTRIBUTION',
    GroundEvening: 'PUROLATOR_GROUND_EVENING',
    GroundUs: 'PUROLATOR_GROUND_US',
    QuickShip: 'PUROLATOR_QUICK_SHIP',
    QuickShipEnvelope: 'PUROLATOR_QUICK_SHIP_ENVELOPE',
    QuickShipPack: 'PUROLATOR_QUICK_SHIP_PACK',
    QuickShipBox: 'PUROLATOR_QUICK_SHIP_BOX'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.PurolatorStockTypes = {
    _4x6: '4x6',
    _85x11: '8.5x11'
};
exports.Rate1TransportationModeEnum = {
    Parcel: 'PARCEL'
};
exports.RateMinimumRowRateTableTypeEnum = {
    RateMinimum: 'RATE_MINIMUM'
};
exports.RateMinimumTableRateTableTypeEnum = {
    RateMinimum: 'RATE_MINIMUM'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.RateStatus = {
    Created: 'CREATED',
    Processing: 'PROCESSING',
    Errored: 'ERRORED',
    Succeeded: 'SUCCEEDED',
    Cancelled: 'CANCELLED',
    Expired: 'EXPIRED',
    Revoked: 'REVOKED',
    Completed: 'COMPLETED'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.RecipientCustomsIdTypes = {
    Company: 'COMPANY',
    Individual: 'INDIVIDUAL',
    Passport: 'PASSPORT'
};
exports.RegionConstraintConstraintTypeEnum = {
    Region: 'REGION'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.RegulatoryControlTypes = {
    FoodOrPerishable: 'FOOD_OR_PERISHABLE',
    Nafta: 'NAFTA',
    NotApplicableForLowCustomsValueException: 'NOT_APPLICABLE_FOR_LOW_CUSTOMS_VALUE_EXCEPTION',
    NotInFreeCirculation: 'NOT_IN_FREE_CIRCULATION'
};
exports.ResponseAddProviderAccountProvidersProviderCodePostProviderCodeEnum = {
    Fedex: 'FEDEX',
    ShipwellFtl: 'SHIPWELL_FTL',
    Ups: 'UPS',
    Usps: 'USPS',
    Any: 'ANY'
};
exports.ResponseGetProviderAccountProvidersProviderCodeIdGetProviderCodeEnum = {
    Fedex: 'FEDEX',
    ShipwellFtl: 'SHIPWELL_FTL',
    Ups: 'UPS',
    Usps: 'USPS',
    Any: 'ANY'
};
exports.ResponseGetRateRateRequestsRateRequestIdRatesRateIdGetTransportationModeEnum = {
    Parcel: 'PARCEL'
};
exports.ResponseGetRateRatesRateRequestIdRateIdGetTransportationModeEnum = {
    Parcel: 'PARCEL'
};
exports.ResponsePostRateRatesRateRequestIdRateIdPostTransportationModeEnum = {
    Parcel: 'PARCEL'
};
exports.ResponsePutRateRatesRateRequestIdIdPutTransportationModeEnum = {
    Parcel: 'PARCEL'
};
exports.ResponseUpdateProviderAccountProvidersProviderCodeAccountIdPutProviderCodeEnum = {
    Fedex: 'FEDEX',
    ShipwellFtl: 'SHIPWELL_FTL',
    Ups: 'UPS',
    Usps: 'USPS',
    Any: 'ANY'
};
exports.RevokeShipmentResponseResponseTypeEnum = {
    Revoke: 'REVOKE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ShipmentMode = {
    Ltl: 'LTL',
    Parcel: 'PARCEL',
    Vltl: 'VLTL',
    Ftl: 'FTL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.ShipmentState = {
    Quoting: 'QUOTING',
    QuotingAccepted: 'QUOTING_ACCEPTED',
    Pending: 'PENDING',
    Tendered: 'TENDERED',
    Dispatched: 'DISPATCHED',
    InTransit: 'IN_TRANSIT',
    AtPickup: 'AT_PICKUP',
    AtDelivery: 'AT_DELIVERY',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    Error: 'ERROR'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.SignatureTypes = {
    AdultSignature: 'ADULT_SIGNATURE',
    DirectSignature: 'DIRECT_SIGNATURE',
    NoSignature: 'NO_SIGNATURE',
    IndirectSignature: 'INDIRECT_SIGNATURE',
    ServiceDefault: 'SERVICE_DEFAULT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.SpecialServices = {
    Cod: 'COD',
    DryIce: 'DRY_ICE',
    SignatureOption: 'SIGNATURE_OPTION',
    Hazmat: 'HAZMAT',
    Alcohol: 'ALCOHOL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.StopActivityEventType = {
    Arrived: 'ARRIVED',
    Departed: 'DEPARTED',
    NotStarted: 'NOT_STARTED',
    OnTheWayToArrive: 'ON_THE_WAY_TO_ARRIVE',
    LoadPickup: 'LOAD_PICKUP',
    LoadDelivered: 'LOAD_DELIVERED'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.StopReason = {
    Load: 'LOAD',
    Unload: 'UNLOAD'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TemperatureUnit = {
    Celsius: 'CELSIUS',
    Fahrenheit: 'FAHRENHEIT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.TransportationMode = {
    Drayage: 'DRAYAGE',
    Ftl: 'FTL',
    Ltl: 'LTL',
    Parcel: 'PARCEL',
    Rail: 'RAIL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.UPSImageTypes = {
    Pdf: 'PDF',
    Zpl: 'ZPL',
    Epl: 'EPL',
    Png: 'PNG'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.UPSPackageTypes = {
    Letter: 'UPS_LETTER',
    ExpressBox: 'UPS_EXPRESS_BOX',
    _25KgBox: 'UPS_25KG_BOX',
    _10KgBox: 'UPS_10KG_BOX',
    Tube: 'UPS_TUBE',
    Pak: 'UPS_PAK',
    SmallExpressBox: 'UPS_SMALL_EXPRESS_BOX',
    MediumExpressBox: 'UPS_MEDIUM_EXPRESS_BOX',
    LargeExpressBox: 'UPS_LARGE_EXPRESS_BOX'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.UPSServiceTypes = {
    Ground: 'GROUND',
    UpsStandard: 'UPS_STANDARD',
    UpsSaver: 'UPS_SAVER',
    Express: 'EXPRESS',
    ExpressPlus: 'EXPRESS_PLUS',
    Expedited: 'EXPEDITED',
    NextDayAir: 'NEXT_DAY_AIR',
    NextDayAirSaver: 'NEXT_DAY_AIR_SAVER',
    NextDayAirEarlyAm: 'NEXT_DAY_AIR_EARLY_AM',
    SecondDayAir: 'SECOND_DAY_AIR',
    SecondDayAirAm: 'SECOND_DAY_AIR_AM',
    ThreeDaySelect: 'THREE_DAY_SELECT'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.UPSStockTypes = {
    _4X6: 'STOCK_4X6',
    _4X8: 'STOCK_4X8'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.USPSImageTypes = {
    Png: 'PNG',
    Pdf: 'PDF',
    Zpl: 'ZPL',
    Epl2: 'EPL2'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.USPSPackageTypes = {
    Card: 'USPS_CARD',
    Letter: 'USPS_LETTER',
    Flat: 'USPS_FLAT',
    FlatRateEnvelope: 'USPS_FLAT_RATE_ENVELOPE',
    FlatRateLegalEnvelope: 'USPS_FLAT_RATE_LEGAL_ENVELOPE',
    FlatRatePaddedEnvelope: 'USPS_FLAT_RATE_PADDED_ENVELOPE',
    Parcel: 'USPS_PARCEL',
    IrregularParcel: 'USPS_IRREGULAR_PARCEL',
    SoftPack: 'USPS_SOFT_PACK',
    SmallFlatRateBox: 'USPS_SMALL_FLAT_RATE_BOX',
    MediumFlatRateBox: 'USPS_MEDIUM_FLAT_RATE_BOX',
    LargeFlatRateBox: 'USPS_LARGE_FLAT_RATE_BOX',
    LargeFlatRateBoxApofpo: 'USPS_LARGE_FLAT_RATE_BOX_APOFPO',
    RegionalRateBoxA: 'USPS_REGIONAL_RATE_BOX_A',
    RegionalRateBoxB: 'USPS_REGIONAL_RATE_BOX_B',
    LargeParcel: 'USPS_LARGE_PARCEL',
    FlatRateGiftCardEnvelope: 'USPS_FLAT_RATE_GIFT_CARD_ENVELOPE',
    FlatRateWindowEnvelope: 'USPS_FLAT_RATE_WINDOW_ENVELOPE',
    FlatRateCardboardEnvelope: 'USPS_FLAT_RATE_CARDBOARD_ENVELOPE',
    SmallFlatRateEnvelope: 'USPS_SMALL_FLAT_RATE_ENVELOPE',
    LargeFlatRateBoardGameBox: 'USPS_LARGE_FLAT_RATE_BOARD_GAME_BOX'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.USPSServiceTypes = {
    First: 'FIRST',
    Priority: 'PRIORITY',
    Express: 'EXPRESS',
    ParcelSelect: 'PARCEL_SELECT',
    LibraryMail: 'LIBRARY_MAIL',
    MediaMail: 'MEDIA_MAIL',
    FirstClassMailInternational: 'FIRST_CLASS_MAIL_INTERNATIONAL',
    FirstClassPackageInternationalService: 'FIRST_CLASS_PACKAGE_INTERNATIONAL_SERVICE',
    PriorityMailInternational: 'PRIORITY_MAIL_INTERNATIONAL',
    ExpressMailInternational: 'EXPRESS_MAIL_INTERNATIONAL'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.USPSStockTypes = {
    _4x6: '4x6',
    _4x4: '4x4',
    _85x11: '8.5x11',
    _7x3: '7x3',
    _6x4: '6x4'
};
exports.UberCapacityProviderAccountSchemaProviderCodeEnum = {
    Fedex: 'FEDEX',
    ShipwellFtl: 'SHIPWELL_FTL',
    Ups: 'UPS',
    Usps: 'USPS',
    Any: 'ANY'
};
exports.UpdateAppointmentEventTypeEnum = {
    AppointmentUpdated: 'APPOINTMENT_UPDATED'
};
exports.UpdateDiscountPercentageTableRateTableTypeEnum = {
    DiscountPercentage: 'DISCOUNT_PERCENTAGE'
};
exports.UpdateEtaEventTypeEnum = {
    EtaUpdated: 'ETA_UPDATED'
};
exports.UpdateFtlEquipmentEventTypeEnum = {
    EquipmentUpdated: 'EQUIPMENT_UPDATED'
};
exports.UpdateFtlStopActivityEventTypeEnum = {
    StopActivity: 'STOP_ACTIVITY'
};
exports.UpdateLocationEventTypeEnum = {
    LocationUpdated: 'LOCATION_UPDATED'
};
exports.UpdateRateMinimumTableRateTableTypeEnum = {
    RateMinimum: 'RATE_MINIMUM'
};
exports.UpdateShipmentStateEventTypeEnum = {
    ShipmentStateUpdated: 'SHIPMENT_STATE_UPDATED'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.VolumeUnit = {
    Ft: 'CUBIC_FT',
    M: 'CUBIC_M'
};
exports.VolumetricMeasurementMeasurementTypeEnum = {
    Volume: 'VOLUME'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.WeightQualifier = {
    PerItem: 'PER_ITEM',
    Gross: 'GROSS'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.WeightUnit = {
    Kg: 'KG',
    Lb: 'LB',
    Oz: 'OZ'
};
/**
 * AlternativeApi - axios parameter creator
 * @export
 */
var AlternativeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * The same route as the \'/rates/{rate_request_id}/failures\' but with more suitable URL.
         * @summary Get Rate Failures
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateFailuresRateRequestsRateRequestIdFailuresGet: function (rateRequestId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1], args_1, true), void 0, function (rateRequestId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateFailuresRateRequestsRateRequestIdFailuresGet', 'rateRequestId', rateRequestId);
                            localVarPath = "/rate-requests/{rate_request_id}/failures"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}/{rate_id}\' but with more suitable URL.
         * @summary Get Rate
         * @param {string} rateRequestId
         * @param {string} rateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRateRequestsRateRequestIdRatesRateIdGet: function (rateRequestId_1, rateId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1, rateId_1], args_1, true), void 0, function (rateRequestId, rateId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateRateRequestsRateRequestIdRatesRateIdGet', 'rateRequestId', rateRequestId);
                            // verify required parameter 'rateId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateRateRequestsRateRequestIdRatesRateIdGet', 'rateId', rateId);
                            localVarPath = "/rate-requests/{rate_request_id}/rates/{rate_id}"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)))
                                .replace("{".concat("rate_id", "}"), encodeURIComponent(String(rateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}\' but with more suitable URL.
         * @summary Get Rates
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesRateRequestsRateRequestIdRatesGet: function (rateRequestId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1], args_1, true), void 0, function (rateRequestId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getRatesRateRequestsRateRequestIdRatesGet', 'rateRequestId', rateRequestId);
                            localVarPath = "/rate-requests/{rate_request_id}/rates"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AlternativeApiAxiosParamCreator = AlternativeApiAxiosParamCreator;
/**
 * AlternativeApi - functional programming interface
 * @export
 */
var AlternativeApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AlternativeApiAxiosParamCreator)(configuration);
    return {
        /**
         * The same route as the \'/rates/{rate_request_id}/failures\' but with more suitable URL.
         * @summary Get Rate Failures
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateFailuresRateRequestsRateRequestIdFailuresGet: function (rateRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateFailuresRateRequestsRateRequestIdFailuresGet(rateRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AlternativeApi.getRateFailuresRateRequestsRateRequestIdFailuresGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}/{rate_id}\' but with more suitable URL.
         * @summary Get Rate
         * @param {string} rateRequestId
         * @param {string} rateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRateRequestsRateRequestIdRatesRateIdGet: function (rateRequestId, rateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateRateRequestsRateRequestIdRatesRateIdGet(rateRequestId, rateId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AlternativeApi.getRateRateRequestsRateRequestIdRatesRateIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}\' but with more suitable URL.
         * @summary Get Rates
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesRateRequestsRateRequestIdRatesGet: function (rateRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRatesRateRequestsRateRequestIdRatesGet(rateRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AlternativeApi.getRatesRateRequestsRateRequestIdRatesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AlternativeApiFp = AlternativeApiFp;
/**
 * AlternativeApi - factory interface
 * @export
 */
var AlternativeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AlternativeApiFp)(configuration);
    return {
        /**
         * The same route as the \'/rates/{rate_request_id}/failures\' but with more suitable URL.
         * @summary Get Rate Failures
         * @param {AlternativeApiGetRateFailuresRateRequestsRateRequestIdFailuresGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateFailuresRateRequestsRateRequestIdFailuresGet: function (requestParameters, options) {
            return localVarFp.getRateFailuresRateRequestsRateRequestIdFailuresGet(requestParameters.rateRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}/{rate_id}\' but with more suitable URL.
         * @summary Get Rate
         * @param {AlternativeApiGetRateRateRequestsRateRequestIdRatesRateIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRateRequestsRateRequestIdRatesRateIdGet: function (requestParameters, options) {
            return localVarFp.getRateRateRequestsRateRequestIdRatesRateIdGet(requestParameters.rateRequestId, requestParameters.rateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}\' but with more suitable URL.
         * @summary Get Rates
         * @param {AlternativeApiGetRatesRateRequestsRateRequestIdRatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesRateRequestsRateRequestIdRatesGet: function (requestParameters, options) {
            return localVarFp.getRatesRateRequestsRateRequestIdRatesGet(requestParameters.rateRequestId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AlternativeApiFactory = AlternativeApiFactory;
/**
 * AlternativeApi - object-oriented interface
 * @export
 * @class AlternativeApi
 * @extends {BaseAPI}
 */
var AlternativeApi = /** @class */ (function (_super) {
    __extends(AlternativeApi, _super);
    function AlternativeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * The same route as the \'/rates/{rate_request_id}/failures\' but with more suitable URL.
     * @summary Get Rate Failures
     * @param {AlternativeApiGetRateFailuresRateRequestsRateRequestIdFailuresGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlternativeApi
     */
    AlternativeApi.prototype.getRateFailuresRateRequestsRateRequestIdFailuresGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AlternativeApiFp)(this.configuration).getRateFailuresRateRequestsRateRequestIdFailuresGet(requestParameters.rateRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * The same route as the \'/rates/{rate_request_id}/{rate_id}\' but with more suitable URL.
     * @summary Get Rate
     * @param {AlternativeApiGetRateRateRequestsRateRequestIdRatesRateIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlternativeApi
     */
    AlternativeApi.prototype.getRateRateRequestsRateRequestIdRatesRateIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AlternativeApiFp)(this.configuration).getRateRateRequestsRateRequestIdRatesRateIdGet(requestParameters.rateRequestId, requestParameters.rateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * The same route as the \'/rates/{rate_request_id}\' but with more suitable URL.
     * @summary Get Rates
     * @param {AlternativeApiGetRatesRateRequestsRateRequestIdRatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlternativeApi
     */
    AlternativeApi.prototype.getRatesRateRequestsRateRequestIdRatesGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AlternativeApiFp)(this.configuration).getRatesRateRequestsRateRequestIdRatesGet(requestParameters.rateRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AlternativeApi;
}(base_1.BaseAPI));
exports.AlternativeApi = AlternativeApi;
/**
 * CarrierTariffEffectiveApi - axios parameter creator
 * @export
 */
var CarrierTariffEffectiveApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Creating a new Carrier Tariff Effective Date row.
         * @summary Create Carrier Tariff Effective
         * @param {CreateCarrierTariffEffective} createCarrierTariffEffective
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarrierTariffEffectiveTariffsPost: function (createCarrierTariffEffective_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createCarrierTariffEffective_1], args_1, true), void 0, function (createCarrierTariffEffective, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createCarrierTariffEffective' is not null or undefined
                            (0, common_1.assertParamExists)('createCarrierTariffEffectiveTariffsPost', 'createCarrierTariffEffective', createCarrierTariffEffective);
                            localVarPath = "/tariffs";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCarrierTariffEffective, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updating Carrier Tariff Effective Date by ID.
         * @summary Delete Carrier Tariff Effective
         * @param {string} tariffEffectiveId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarrierTariffEffectiveTariffsTariffEffectiveIdDelete: function (tariffEffectiveId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tariffEffectiveId_1], args_1, true), void 0, function (tariffEffectiveId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tariffEffectiveId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteCarrierTariffEffectiveTariffsTariffEffectiveIdDelete', 'tariffEffectiveId', tariffEffectiveId);
                            localVarPath = "/tariffs/{tariff_effective_id}"
                                .replace("{".concat("tariff_effective_id", "}"), encodeURIComponent(String(tariffEffectiveId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Getting all Carrier Tariff Effective Date rows.
         * @summary Get All Carrier Tariff Effective
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [tariffName] Filter by tariff name
         * @param {string} [tariffType] Filter by type: [\&#39;INTERSTATE\&#39;, \&#39;INTRASTATE\&#39;, \&#39;CANADA\&#39;]
         * @param {string} [carrierReferenceQualifier] If set, carrier_reference__value is also required
         * @param {string} [carrierReferenceValue] If set, carrier_reference__qualifier is also required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCarrierTariffEffectiveTariffsGet: function (page_1, limit_1, tariffName_1, tariffType_1, carrierReferenceQualifier_1, carrierReferenceValue_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, limit_1, tariffName_1, tariffType_1, carrierReferenceQualifier_1, carrierReferenceValue_1], args_1, true), void 0, function (page, limit, tariffName, tariffType, carrierReferenceQualifier, carrierReferenceValue, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/tariffs";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (tariffName !== undefined) {
                                localVarQueryParameter['tariff_name'] = tariffName;
                            }
                            if (tariffType !== undefined) {
                                localVarQueryParameter['tariff_type'] = tariffType;
                            }
                            if (carrierReferenceQualifier !== undefined) {
                                localVarQueryParameter['carrier_reference__qualifier'] = carrierReferenceQualifier;
                            }
                            if (carrierReferenceValue !== undefined) {
                                localVarQueryParameter['carrier_reference__value'] = carrierReferenceValue;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Getting Carrier Tariff Effective Date by ID.
         * @summary Get Carrier Tariff Effective
         * @param {string} tariffEffectiveId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierTariffEffectiveTariffsTariffEffectiveIdGet: function (tariffEffectiveId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tariffEffectiveId_1], args_1, true), void 0, function (tariffEffectiveId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tariffEffectiveId' is not null or undefined
                            (0, common_1.assertParamExists)('getCarrierTariffEffectiveTariffsTariffEffectiveIdGet', 'tariffEffectiveId', tariffEffectiveId);
                            localVarPath = "/tariffs/{tariff_effective_id}"
                                .replace("{".concat("tariff_effective_id", "}"), encodeURIComponent(String(tariffEffectiveId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updating Carrier Tariff Effective Date by ID.
         * @summary Update Carrier Tariff Effective
         * @param {string} tariffEffectiveId
         * @param {CreateCarrierTariffEffective} createCarrierTariffEffective
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarrierTariffEffectiveTariffsTariffEffectiveIdPut: function (tariffEffectiveId_1, createCarrierTariffEffective_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tariffEffectiveId_1, createCarrierTariffEffective_1], args_1, true), void 0, function (tariffEffectiveId, createCarrierTariffEffective, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tariffEffectiveId' is not null or undefined
                            (0, common_1.assertParamExists)('updateCarrierTariffEffectiveTariffsTariffEffectiveIdPut', 'tariffEffectiveId', tariffEffectiveId);
                            // verify required parameter 'createCarrierTariffEffective' is not null or undefined
                            (0, common_1.assertParamExists)('updateCarrierTariffEffectiveTariffsTariffEffectiveIdPut', 'createCarrierTariffEffective', createCarrierTariffEffective);
                            localVarPath = "/tariffs/{tariff_effective_id}"
                                .replace("{".concat("tariff_effective_id", "}"), encodeURIComponent(String(tariffEffectiveId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCarrierTariffEffective, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CarrierTariffEffectiveApiAxiosParamCreator = CarrierTariffEffectiveApiAxiosParamCreator;
/**
 * CarrierTariffEffectiveApi - functional programming interface
 * @export
 */
var CarrierTariffEffectiveApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CarrierTariffEffectiveApiAxiosParamCreator)(configuration);
    return {
        /**
         * Creating a new Carrier Tariff Effective Date row.
         * @summary Create Carrier Tariff Effective
         * @param {CreateCarrierTariffEffective} createCarrierTariffEffective
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarrierTariffEffectiveTariffsPost: function (createCarrierTariffEffective, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCarrierTariffEffectiveTariffsPost(createCarrierTariffEffective, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CarrierTariffEffectiveApi.createCarrierTariffEffectiveTariffsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Updating Carrier Tariff Effective Date by ID.
         * @summary Delete Carrier Tariff Effective
         * @param {string} tariffEffectiveId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarrierTariffEffectiveTariffsTariffEffectiveIdDelete: function (tariffEffectiveId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCarrierTariffEffectiveTariffsTariffEffectiveIdDelete(tariffEffectiveId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CarrierTariffEffectiveApi.deleteCarrierTariffEffectiveTariffsTariffEffectiveIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Getting all Carrier Tariff Effective Date rows.
         * @summary Get All Carrier Tariff Effective
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [tariffName] Filter by tariff name
         * @param {string} [tariffType] Filter by type: [\&#39;INTERSTATE\&#39;, \&#39;INTRASTATE\&#39;, \&#39;CANADA\&#39;]
         * @param {string} [carrierReferenceQualifier] If set, carrier_reference__value is also required
         * @param {string} [carrierReferenceValue] If set, carrier_reference__qualifier is also required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCarrierTariffEffectiveTariffsGet: function (page, limit, tariffName, tariffType, carrierReferenceQualifier, carrierReferenceValue, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllCarrierTariffEffectiveTariffsGet(page, limit, tariffName, tariffType, carrierReferenceQualifier, carrierReferenceValue, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CarrierTariffEffectiveApi.getAllCarrierTariffEffectiveTariffsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Getting Carrier Tariff Effective Date by ID.
         * @summary Get Carrier Tariff Effective
         * @param {string} tariffEffectiveId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierTariffEffectiveTariffsTariffEffectiveIdGet: function (tariffEffectiveId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCarrierTariffEffectiveTariffsTariffEffectiveIdGet(tariffEffectiveId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CarrierTariffEffectiveApi.getCarrierTariffEffectiveTariffsTariffEffectiveIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Updating Carrier Tariff Effective Date by ID.
         * @summary Update Carrier Tariff Effective
         * @param {string} tariffEffectiveId
         * @param {CreateCarrierTariffEffective} createCarrierTariffEffective
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarrierTariffEffectiveTariffsTariffEffectiveIdPut: function (tariffEffectiveId, createCarrierTariffEffective, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCarrierTariffEffectiveTariffsTariffEffectiveIdPut(tariffEffectiveId, createCarrierTariffEffective, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CarrierTariffEffectiveApi.updateCarrierTariffEffectiveTariffsTariffEffectiveIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CarrierTariffEffectiveApiFp = CarrierTariffEffectiveApiFp;
/**
 * CarrierTariffEffectiveApi - factory interface
 * @export
 */
var CarrierTariffEffectiveApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CarrierTariffEffectiveApiFp)(configuration);
    return {
        /**
         * Creating a new Carrier Tariff Effective Date row.
         * @summary Create Carrier Tariff Effective
         * @param {CarrierTariffEffectiveApiCreateCarrierTariffEffectiveTariffsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarrierTariffEffectiveTariffsPost: function (requestParameters, options) {
            return localVarFp.createCarrierTariffEffectiveTariffsPost(requestParameters.createCarrierTariffEffective, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updating Carrier Tariff Effective Date by ID.
         * @summary Delete Carrier Tariff Effective
         * @param {CarrierTariffEffectiveApiDeleteCarrierTariffEffectiveTariffsTariffEffectiveIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarrierTariffEffectiveTariffsTariffEffectiveIdDelete: function (requestParameters, options) {
            return localVarFp.deleteCarrierTariffEffectiveTariffsTariffEffectiveIdDelete(requestParameters.tariffEffectiveId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Getting all Carrier Tariff Effective Date rows.
         * @summary Get All Carrier Tariff Effective
         * @param {CarrierTariffEffectiveApiGetAllCarrierTariffEffectiveTariffsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCarrierTariffEffectiveTariffsGet: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getAllCarrierTariffEffectiveTariffsGet(requestParameters.page, requestParameters.limit, requestParameters.tariffName, requestParameters.tariffType, requestParameters.carrierReferenceQualifier, requestParameters.carrierReferenceValue, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Getting Carrier Tariff Effective Date by ID.
         * @summary Get Carrier Tariff Effective
         * @param {CarrierTariffEffectiveApiGetCarrierTariffEffectiveTariffsTariffEffectiveIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarrierTariffEffectiveTariffsTariffEffectiveIdGet: function (requestParameters, options) {
            return localVarFp.getCarrierTariffEffectiveTariffsTariffEffectiveIdGet(requestParameters.tariffEffectiveId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updating Carrier Tariff Effective Date by ID.
         * @summary Update Carrier Tariff Effective
         * @param {CarrierTariffEffectiveApiUpdateCarrierTariffEffectiveTariffsTariffEffectiveIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarrierTariffEffectiveTariffsTariffEffectiveIdPut: function (requestParameters, options) {
            return localVarFp.updateCarrierTariffEffectiveTariffsTariffEffectiveIdPut(requestParameters.tariffEffectiveId, requestParameters.createCarrierTariffEffective, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CarrierTariffEffectiveApiFactory = CarrierTariffEffectiveApiFactory;
/**
 * CarrierTariffEffectiveApi - object-oriented interface
 * @export
 * @class CarrierTariffEffectiveApi
 * @extends {BaseAPI}
 */
var CarrierTariffEffectiveApi = /** @class */ (function (_super) {
    __extends(CarrierTariffEffectiveApi, _super);
    function CarrierTariffEffectiveApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creating a new Carrier Tariff Effective Date row.
     * @summary Create Carrier Tariff Effective
     * @param {CarrierTariffEffectiveApiCreateCarrierTariffEffectiveTariffsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTariffEffectiveApi
     */
    CarrierTariffEffectiveApi.prototype.createCarrierTariffEffectiveTariffsPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CarrierTariffEffectiveApiFp)(this.configuration).createCarrierTariffEffectiveTariffsPost(requestParameters.createCarrierTariffEffective, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updating Carrier Tariff Effective Date by ID.
     * @summary Delete Carrier Tariff Effective
     * @param {CarrierTariffEffectiveApiDeleteCarrierTariffEffectiveTariffsTariffEffectiveIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTariffEffectiveApi
     */
    CarrierTariffEffectiveApi.prototype.deleteCarrierTariffEffectiveTariffsTariffEffectiveIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CarrierTariffEffectiveApiFp)(this.configuration).deleteCarrierTariffEffectiveTariffsTariffEffectiveIdDelete(requestParameters.tariffEffectiveId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Getting all Carrier Tariff Effective Date rows.
     * @summary Get All Carrier Tariff Effective
     * @param {CarrierTariffEffectiveApiGetAllCarrierTariffEffectiveTariffsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTariffEffectiveApi
     */
    CarrierTariffEffectiveApi.prototype.getAllCarrierTariffEffectiveTariffsGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.CarrierTariffEffectiveApiFp)(this.configuration).getAllCarrierTariffEffectiveTariffsGet(requestParameters.page, requestParameters.limit, requestParameters.tariffName, requestParameters.tariffType, requestParameters.carrierReferenceQualifier, requestParameters.carrierReferenceValue, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Getting Carrier Tariff Effective Date by ID.
     * @summary Get Carrier Tariff Effective
     * @param {CarrierTariffEffectiveApiGetCarrierTariffEffectiveTariffsTariffEffectiveIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTariffEffectiveApi
     */
    CarrierTariffEffectiveApi.prototype.getCarrierTariffEffectiveTariffsTariffEffectiveIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CarrierTariffEffectiveApiFp)(this.configuration).getCarrierTariffEffectiveTariffsTariffEffectiveIdGet(requestParameters.tariffEffectiveId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updating Carrier Tariff Effective Date by ID.
     * @summary Update Carrier Tariff Effective
     * @param {CarrierTariffEffectiveApiUpdateCarrierTariffEffectiveTariffsTariffEffectiveIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTariffEffectiveApi
     */
    CarrierTariffEffectiveApi.prototype.updateCarrierTariffEffectiveTariffsTariffEffectiveIdPut = function (requestParameters, options) {
        var _this = this;
        return (0, exports.CarrierTariffEffectiveApiFp)(this.configuration).updateCarrierTariffEffectiveTariffsTariffEffectiveIdPut(requestParameters.tariffEffectiveId, requestParameters.createCarrierTariffEffective, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CarrierTariffEffectiveApi;
}(base_1.BaseAPI));
exports.CarrierTariffEffectiveApi = CarrierTariffEffectiveApi;
/**
 * DispatchApi - axios parameter creator
 * @export
 */
var DispatchApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Closeout
         * @param {CloseoutRequest} closeoutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeoutDispatchCloseoutPost: function (closeoutRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([closeoutRequest_1], args_1, true), void 0, function (closeoutRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'closeoutRequest' is not null or undefined
                            (0, common_1.assertParamExists)('closeoutDispatchCloseoutPost', 'closeoutRequest', closeoutRequest);
                            localVarPath = "/dispatch/closeout";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(closeoutRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Dispatch Failures
         * @param {string} dispatchId
         * @param {CreateRequestFailure} createRequestFailure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispatchFailuresDispatchDispatchIdFailuresPost: function (dispatchId_1, createRequestFailure_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([dispatchId_1, createRequestFailure_1], args_1, true), void 0, function (dispatchId, createRequestFailure, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dispatchId' is not null or undefined
                            (0, common_1.assertParamExists)('createDispatchFailuresDispatchDispatchIdFailuresPost', 'dispatchId', dispatchId);
                            // verify required parameter 'createRequestFailure' is not null or undefined
                            (0, common_1.assertParamExists)('createDispatchFailuresDispatchDispatchIdFailuresPost', 'createRequestFailure', createRequestFailure);
                            localVarPath = "/dispatch/{dispatch_id}/failures"
                                .replace("{".concat("dispatch_id", "}"), encodeURIComponent(String(dispatchId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createRequestFailure, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete
         * @param {string} trackingNumber
         * @param {DeletionRequest} deletionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDispatchTrackingNumberDelete: function (trackingNumber_1, deletionRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([trackingNumber_1, deletionRequest_1], args_1, true), void 0, function (trackingNumber, deletionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'trackingNumber' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDispatchTrackingNumberDelete', 'trackingNumber', trackingNumber);
                            // verify required parameter 'deletionRequest' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDispatchTrackingNumberDelete', 'deletionRequest', deletionRequest);
                            localVarPath = "/dispatch/{tracking_number}"
                                .replace("{".concat("tracking_number", "}"), encodeURIComponent(String(trackingNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deletionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Dispatch
         * @param {DispatchRequest} dispatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispatchDispatchPost: function (dispatchRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([dispatchRequest_1], args_1, true), void 0, function (dispatchRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dispatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('dispatchDispatchPost', 'dispatchRequest', dispatchRequest);
                            localVarPath = "/dispatch";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dispatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Ftl Dispatch
         * @param {string} dispatchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFtlDispatchDispatchFtlDispatchIdGet: function (dispatchId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([dispatchId_1], args_1, true), void 0, function (dispatchId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dispatchId' is not null or undefined
                            (0, common_1.assertParamExists)('getFtlDispatchDispatchFtlDispatchIdGet', 'dispatchId', dispatchId);
                            localVarPath = "/dispatch/ftl/{dispatch_id}"
                                .replace("{".concat("dispatch_id", "}"), encodeURIComponent(String(dispatchId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Web hook for carrier responding to accepting, declinging, or revoking a dispatch request.
         * @param {string} dispatchId
         * @param {CarrierResponse} carrierResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCarrierResponseDispatchesDispatchIdCarrierResponsePost: function (dispatchId_1, carrierResponse_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([dispatchId_1, carrierResponse_1], args_1, true), void 0, function (dispatchId, carrierResponse, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dispatchId' is not null or undefined
                            (0, common_1.assertParamExists)('postCarrierResponseDispatchesDispatchIdCarrierResponsePost', 'dispatchId', dispatchId);
                            // verify required parameter 'carrierResponse' is not null or undefined
                            (0, common_1.assertParamExists)('postCarrierResponseDispatchesDispatchIdCarrierResponsePost', 'carrierResponse', carrierResponse);
                            localVarPath = "/dispatches/{dispatch_id}/carrier-response"
                                .replace("{".concat("dispatch_id", "}"), encodeURIComponent(String(dispatchId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierResponse, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Ftl Dispatch
         * @param {CreateFtlDispatchRequest} createFtlDispatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFtlDispatchDispatchFtlPost: function (createFtlDispatchRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createFtlDispatchRequest_1], args_1, true), void 0, function (createFtlDispatchRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createFtlDispatchRequest' is not null or undefined
                            (0, common_1.assertParamExists)('postFtlDispatchDispatchFtlPost', 'createFtlDispatchRequest', createFtlDispatchRequest);
                            localVarPath = "/dispatch/ftl";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFtlDispatchRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Dispatched Shipment with execution details.
         * @param {string} dispatchId
         * @param {FtlShipmentDetails} ftlShipmentDetails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFtlShipmentDetailsDispatchesDispatchIdExecutionPost: function (dispatchId_1, ftlShipmentDetails_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([dispatchId_1, ftlShipmentDetails_1], args_1, true), void 0, function (dispatchId, ftlShipmentDetails, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dispatchId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFtlShipmentDetailsDispatchesDispatchIdExecutionPost', 'dispatchId', dispatchId);
                            // verify required parameter 'ftlShipmentDetails' is not null or undefined
                            (0, common_1.assertParamExists)('updateFtlShipmentDetailsDispatchesDispatchIdExecutionPost', 'ftlShipmentDetails', ftlShipmentDetails);
                            localVarPath = "/dispatches/{dispatch_id}/execution"
                                .replace("{".concat("dispatch_id", "}"), encodeURIComponent(String(dispatchId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ftlShipmentDetails, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload documents
         * @param {string} dispatchId
         * @param {DocumentUploadRequest} [documentUploadRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentsDispatchesDispatchIdDocumentsPost: function (dispatchId_1, documentUploadRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([dispatchId_1, documentUploadRequest_1], args_1, true), void 0, function (dispatchId, documentUploadRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dispatchId' is not null or undefined
                            (0, common_1.assertParamExists)('uploadDocumentsDispatchesDispatchIdDocumentsPost', 'dispatchId', dispatchId);
                            localVarPath = "/dispatches/{dispatch_id}/documents"
                                .replace("{".concat("dispatch_id", "}"), encodeURIComponent(String(dispatchId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentUploadRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DispatchApiAxiosParamCreator = DispatchApiAxiosParamCreator;
/**
 * DispatchApi - functional programming interface
 * @export
 */
var DispatchApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DispatchApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Closeout
         * @param {CloseoutRequest} closeoutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeoutDispatchCloseoutPost: function (closeoutRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.closeoutDispatchCloseoutPost(closeoutRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DispatchApi.closeoutDispatchCloseoutPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Dispatch Failures
         * @param {string} dispatchId
         * @param {CreateRequestFailure} createRequestFailure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispatchFailuresDispatchDispatchIdFailuresPost: function (dispatchId, createRequestFailure, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDispatchFailuresDispatchDispatchIdFailuresPost(dispatchId, createRequestFailure, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DispatchApi.createDispatchFailuresDispatchDispatchIdFailuresPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete
         * @param {string} trackingNumber
         * @param {DeletionRequest} deletionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDispatchTrackingNumberDelete: function (trackingNumber, deletionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDispatchTrackingNumberDelete(trackingNumber, deletionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DispatchApi.deleteDispatchTrackingNumberDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Dispatch
         * @param {DispatchRequest} dispatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispatchDispatchPost: function (dispatchRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.dispatchDispatchPost(dispatchRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DispatchApi.dispatchDispatchPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Ftl Dispatch
         * @param {string} dispatchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFtlDispatchDispatchFtlDispatchIdGet: function (dispatchId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFtlDispatchDispatchFtlDispatchIdGet(dispatchId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DispatchApi.getFtlDispatchDispatchFtlDispatchIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Web hook for carrier responding to accepting, declinging, or revoking a dispatch request.
         * @param {string} dispatchId
         * @param {CarrierResponse} carrierResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCarrierResponseDispatchesDispatchIdCarrierResponsePost: function (dispatchId, carrierResponse, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postCarrierResponseDispatchesDispatchIdCarrierResponsePost(dispatchId, carrierResponse, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DispatchApi.postCarrierResponseDispatchesDispatchIdCarrierResponsePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Ftl Dispatch
         * @param {CreateFtlDispatchRequest} createFtlDispatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFtlDispatchDispatchFtlPost: function (createFtlDispatchRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postFtlDispatchDispatchFtlPost(createFtlDispatchRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DispatchApi.postFtlDispatchDispatchFtlPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Dispatched Shipment with execution details.
         * @param {string} dispatchId
         * @param {FtlShipmentDetails} ftlShipmentDetails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFtlShipmentDetailsDispatchesDispatchIdExecutionPost: function (dispatchId, ftlShipmentDetails, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFtlShipmentDetailsDispatchesDispatchIdExecutionPost(dispatchId, ftlShipmentDetails, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DispatchApi.updateFtlShipmentDetailsDispatchesDispatchIdExecutionPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload documents
         * @param {string} dispatchId
         * @param {DocumentUploadRequest} [documentUploadRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentsDispatchesDispatchIdDocumentsPost: function (dispatchId, documentUploadRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadDocumentsDispatchesDispatchIdDocumentsPost(dispatchId, documentUploadRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DispatchApi.uploadDocumentsDispatchesDispatchIdDocumentsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DispatchApiFp = DispatchApiFp;
/**
 * DispatchApi - factory interface
 * @export
 */
var DispatchApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DispatchApiFp)(configuration);
    return {
        /**
         *
         * @summary Closeout
         * @param {DispatchApiCloseoutDispatchCloseoutPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeoutDispatchCloseoutPost: function (requestParameters, options) {
            return localVarFp.closeoutDispatchCloseoutPost(requestParameters.closeoutRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Dispatch Failures
         * @param {DispatchApiCreateDispatchFailuresDispatchDispatchIdFailuresPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispatchFailuresDispatchDispatchIdFailuresPost: function (requestParameters, options) {
            return localVarFp.createDispatchFailuresDispatchDispatchIdFailuresPost(requestParameters.dispatchId, requestParameters.createRequestFailure, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete
         * @param {DispatchApiDeleteDispatchTrackingNumberDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDispatchTrackingNumberDelete: function (requestParameters, options) {
            return localVarFp.deleteDispatchTrackingNumberDelete(requestParameters.trackingNumber, requestParameters.deletionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Dispatch
         * @param {DispatchApiDispatchDispatchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dispatchDispatchPost: function (requestParameters, options) {
            return localVarFp.dispatchDispatchPost(requestParameters.dispatchRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Ftl Dispatch
         * @param {DispatchApiGetFtlDispatchDispatchFtlDispatchIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFtlDispatchDispatchFtlDispatchIdGet: function (requestParameters, options) {
            return localVarFp.getFtlDispatchDispatchFtlDispatchIdGet(requestParameters.dispatchId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Web hook for carrier responding to accepting, declinging, or revoking a dispatch request.
         * @param {DispatchApiPostCarrierResponseDispatchesDispatchIdCarrierResponsePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCarrierResponseDispatchesDispatchIdCarrierResponsePost: function (requestParameters, options) {
            return localVarFp.postCarrierResponseDispatchesDispatchIdCarrierResponsePost(requestParameters.dispatchId, requestParameters.carrierResponse, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Ftl Dispatch
         * @param {DispatchApiPostFtlDispatchDispatchFtlPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFtlDispatchDispatchFtlPost: function (requestParameters, options) {
            return localVarFp.postFtlDispatchDispatchFtlPost(requestParameters.createFtlDispatchRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a Dispatched Shipment with execution details.
         * @param {DispatchApiUpdateFtlShipmentDetailsDispatchesDispatchIdExecutionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFtlShipmentDetailsDispatchesDispatchIdExecutionPost: function (requestParameters, options) {
            return localVarFp.updateFtlShipmentDetailsDispatchesDispatchIdExecutionPost(requestParameters.dispatchId, requestParameters.ftlShipmentDetails, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upload documents
         * @param {DispatchApiUploadDocumentsDispatchesDispatchIdDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentsDispatchesDispatchIdDocumentsPost: function (requestParameters, options) {
            return localVarFp.uploadDocumentsDispatchesDispatchIdDocumentsPost(requestParameters.dispatchId, requestParameters.documentUploadRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DispatchApiFactory = DispatchApiFactory;
/**
 * DispatchApi - object-oriented interface
 * @export
 * @class DispatchApi
 * @extends {BaseAPI}
 */
var DispatchApi = /** @class */ (function (_super) {
    __extends(DispatchApi, _super);
    function DispatchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Closeout
     * @param {DispatchApiCloseoutDispatchCloseoutPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchApi
     */
    DispatchApi.prototype.closeoutDispatchCloseoutPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DispatchApiFp)(this.configuration).closeoutDispatchCloseoutPost(requestParameters.closeoutRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Dispatch Failures
     * @param {DispatchApiCreateDispatchFailuresDispatchDispatchIdFailuresPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchApi
     */
    DispatchApi.prototype.createDispatchFailuresDispatchDispatchIdFailuresPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DispatchApiFp)(this.configuration).createDispatchFailuresDispatchDispatchIdFailuresPost(requestParameters.dispatchId, requestParameters.createRequestFailure, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete
     * @param {DispatchApiDeleteDispatchTrackingNumberDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchApi
     */
    DispatchApi.prototype.deleteDispatchTrackingNumberDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DispatchApiFp)(this.configuration).deleteDispatchTrackingNumberDelete(requestParameters.trackingNumber, requestParameters.deletionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Dispatch
     * @param {DispatchApiDispatchDispatchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchApi
     */
    DispatchApi.prototype.dispatchDispatchPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DispatchApiFp)(this.configuration).dispatchDispatchPost(requestParameters.dispatchRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Ftl Dispatch
     * @param {DispatchApiGetFtlDispatchDispatchFtlDispatchIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchApi
     */
    DispatchApi.prototype.getFtlDispatchDispatchFtlDispatchIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DispatchApiFp)(this.configuration).getFtlDispatchDispatchFtlDispatchIdGet(requestParameters.dispatchId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Web hook for carrier responding to accepting, declinging, or revoking a dispatch request.
     * @param {DispatchApiPostCarrierResponseDispatchesDispatchIdCarrierResponsePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchApi
     */
    DispatchApi.prototype.postCarrierResponseDispatchesDispatchIdCarrierResponsePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DispatchApiFp)(this.configuration).postCarrierResponseDispatchesDispatchIdCarrierResponsePost(requestParameters.dispatchId, requestParameters.carrierResponse, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Ftl Dispatch
     * @param {DispatchApiPostFtlDispatchDispatchFtlPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchApi
     */
    DispatchApi.prototype.postFtlDispatchDispatchFtlPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DispatchApiFp)(this.configuration).postFtlDispatchDispatchFtlPost(requestParameters.createFtlDispatchRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a Dispatched Shipment with execution details.
     * @param {DispatchApiUpdateFtlShipmentDetailsDispatchesDispatchIdExecutionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchApi
     */
    DispatchApi.prototype.updateFtlShipmentDetailsDispatchesDispatchIdExecutionPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DispatchApiFp)(this.configuration).updateFtlShipmentDetailsDispatchesDispatchIdExecutionPost(requestParameters.dispatchId, requestParameters.ftlShipmentDetails, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upload documents
     * @param {DispatchApiUploadDocumentsDispatchesDispatchIdDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DispatchApi
     */
    DispatchApi.prototype.uploadDocumentsDispatchesDispatchIdDocumentsPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DispatchApiFp)(this.configuration).uploadDocumentsDispatchesDispatchIdDocumentsPost(requestParameters.dispatchId, requestParameters.documentUploadRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DispatchApi;
}(base_1.BaseAPI));
exports.DispatchApi = DispatchApi;
/**
 * DocumentsApi - axios parameter creator
 * @export
 */
var DocumentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Document Upload
         * @param {FedExDocumentUploadRequest} fedExDocumentUploadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentUploadDocumentsUploadPost: function (fedExDocumentUploadRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([fedExDocumentUploadRequest_1], args_1, true), void 0, function (fedExDocumentUploadRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fedExDocumentUploadRequest' is not null or undefined
                            (0, common_1.assertParamExists)('documentUploadDocumentsUploadPost', 'fedExDocumentUploadRequest', fedExDocumentUploadRequest);
                            localVarPath = "/documents/upload";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fedExDocumentUploadRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Endpoint for uploading multiple documents by one request.
         * @summary Documents Upload
         * @param {BodyDocumentsUploadV2DocumentsUploadPost} [bodyDocumentsUploadV2DocumentsUploadPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsUploadV2DocumentsUploadPost: function (bodyDocumentsUploadV2DocumentsUploadPost_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bodyDocumentsUploadV2DocumentsUploadPost_1], args_1, true), void 0, function (bodyDocumentsUploadV2DocumentsUploadPost, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v2/documents/upload";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bodyDocumentsUploadV2DocumentsUploadPost, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DocumentsApiAxiosParamCreator = DocumentsApiAxiosParamCreator;
/**
 * DocumentsApi - functional programming interface
 * @export
 */
var DocumentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DocumentsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Document Upload
         * @param {FedExDocumentUploadRequest} fedExDocumentUploadRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentUploadDocumentsUploadPost: function (fedExDocumentUploadRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.documentUploadDocumentsUploadPost(fedExDocumentUploadRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentsApi.documentUploadDocumentsUploadPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Endpoint for uploading multiple documents by one request.
         * @summary Documents Upload
         * @param {BodyDocumentsUploadV2DocumentsUploadPost} [bodyDocumentsUploadV2DocumentsUploadPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsUploadV2DocumentsUploadPost: function (bodyDocumentsUploadV2DocumentsUploadPost, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.documentsUploadV2DocumentsUploadPost(bodyDocumentsUploadV2DocumentsUploadPost, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DocumentsApi.documentsUploadV2DocumentsUploadPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DocumentsApiFp = DocumentsApiFp;
/**
 * DocumentsApi - factory interface
 * @export
 */
var DocumentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DocumentsApiFp)(configuration);
    return {
        /**
         *
         * @summary Document Upload
         * @param {DocumentsApiDocumentUploadDocumentsUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentUploadDocumentsUploadPost: function (requestParameters, options) {
            return localVarFp.documentUploadDocumentsUploadPost(requestParameters.fedExDocumentUploadRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Endpoint for uploading multiple documents by one request.
         * @summary Documents Upload
         * @param {DocumentsApiDocumentsUploadV2DocumentsUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsUploadV2DocumentsUploadPost: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.documentsUploadV2DocumentsUploadPost(requestParameters.bodyDocumentsUploadV2DocumentsUploadPost, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DocumentsApiFactory = DocumentsApiFactory;
/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
var DocumentsApi = /** @class */ (function (_super) {
    __extends(DocumentsApi, _super);
    function DocumentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Document Upload
     * @param {DocumentsApiDocumentUploadDocumentsUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.documentUploadDocumentsUploadPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).documentUploadDocumentsUploadPost(requestParameters.fedExDocumentUploadRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Endpoint for uploading multiple documents by one request.
     * @summary Documents Upload
     * @param {DocumentsApiDocumentsUploadV2DocumentsUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.documentsUploadV2DocumentsUploadPost = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DocumentsApiFp)(this.configuration).documentsUploadV2DocumentsUploadPost(requestParameters.bodyDocumentsUploadV2DocumentsUploadPost, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DocumentsApi;
}(base_1.BaseAPI));
exports.DocumentsApi = DocumentsApi;
/**
 * FreightAllKindsMappingApi - axios parameter creator
 * @export
 */
var FreightAllKindsMappingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Updating existing FAK rows or/and add new ones if not exist.
         * @summary Bulk Upsert
         * @param {Array<CreateFreightAllKindsMapping>} createFreightAllKindsMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpsertRatesFakMappingsBulkPost: function (createFreightAllKindsMapping_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createFreightAllKindsMapping_1], args_1, true), void 0, function (createFreightAllKindsMapping, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createFreightAllKindsMapping' is not null or undefined
                            (0, common_1.assertParamExists)('bulkUpsertRatesFakMappingsBulkPost', 'createFreightAllKindsMapping', createFreightAllKindsMapping);
                            localVarPath = "/rates/fak-mappings/bulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFreightAllKindsMapping, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a new freight all kinds mapping record
         * @summary Create Fak Mapping
         * @param {CreateFreightAllKindsMapping} createFreightAllKindsMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFakMappingRatesFakMappingsPost: function (createFreightAllKindsMapping_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createFreightAllKindsMapping_1], args_1, true), void 0, function (createFreightAllKindsMapping, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createFreightAllKindsMapping' is not null or undefined
                            (0, common_1.assertParamExists)('createFakMappingRatesFakMappingsPost', 'createFreightAllKindsMapping', createFreightAllKindsMapping);
                            localVarPath = "/rates/fak-mappings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFreightAllKindsMapping, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a fak record
         * @summary Delete Fak Mapping
         * @param {string} fakId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFakMappingRatesFakMappingsFakIdDelete: function (fakId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([fakId_1], args_1, true), void 0, function (fakId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fakId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteFakMappingRatesFakMappingsFakIdDelete', 'fakId', fakId);
                            localVarPath = "/rates/fak-mappings/{fak_id}"
                                .replace("{".concat("fak_id", "}"), encodeURIComponent(String(fakId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Getting all FAK rows by specific query filters.
         * @summary Get All Fak Mappings
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [originalNmfcCode] Filter by original NMFC code.
         * @param {string} [mappedNmfcCode] Filter by mapped FAK code.
         * @param {string} [carrierReferenceQualifier] If set, carrier_reference__value is also required
         * @param {string} [carrierReferenceValue] If set, carrier_reference__qualifier is also required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFakMappingsRatesFakMappingsGet: function (page_1, limit_1, originalNmfcCode_1, mappedNmfcCode_1, carrierReferenceQualifier_1, carrierReferenceValue_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, limit_1, originalNmfcCode_1, mappedNmfcCode_1, carrierReferenceQualifier_1, carrierReferenceValue_1], args_1, true), void 0, function (page, limit, originalNmfcCode, mappedNmfcCode, carrierReferenceQualifier, carrierReferenceValue, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/rates/fak-mappings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (originalNmfcCode !== undefined) {
                                localVarQueryParameter['original_nmfc_code'] = originalNmfcCode;
                            }
                            if (mappedNmfcCode !== undefined) {
                                localVarQueryParameter['mapped_nmfc_code'] = mappedNmfcCode;
                            }
                            if (carrierReferenceQualifier !== undefined) {
                                localVarQueryParameter['carrier_reference__qualifier'] = carrierReferenceQualifier;
                            }
                            if (carrierReferenceValue !== undefined) {
                                localVarQueryParameter['carrier_reference__value'] = carrierReferenceValue;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a fak record
         * @summary Get Fak Mapping
         * @param {string} fakId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFakMappingRatesFakMappingsFakIdGet: function (fakId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([fakId_1], args_1, true), void 0, function (fakId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fakId' is not null or undefined
                            (0, common_1.assertParamExists)('getFakMappingRatesFakMappingsFakIdGet', 'fakId', fakId);
                            localVarPath = "/rates/fak-mappings/{fak_id}"
                                .replace("{".concat("fak_id", "}"), encodeURIComponent(String(fakId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a fak record
         * @summary Update Fak Mapping
         * @param {string} fakId
         * @param {CreateFreightAllKindsMapping} createFreightAllKindsMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFakMappingRatesFakMappingsFakIdPut: function (fakId_1, createFreightAllKindsMapping_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([fakId_1, createFreightAllKindsMapping_1], args_1, true), void 0, function (fakId, createFreightAllKindsMapping, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fakId' is not null or undefined
                            (0, common_1.assertParamExists)('updateFakMappingRatesFakMappingsFakIdPut', 'fakId', fakId);
                            // verify required parameter 'createFreightAllKindsMapping' is not null or undefined
                            (0, common_1.assertParamExists)('updateFakMappingRatesFakMappingsFakIdPut', 'createFreightAllKindsMapping', createFreightAllKindsMapping);
                            localVarPath = "/rates/fak-mappings/{fak_id}"
                                .replace("{".concat("fak_id", "}"), encodeURIComponent(String(fakId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFreightAllKindsMapping, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FreightAllKindsMappingApiAxiosParamCreator = FreightAllKindsMappingApiAxiosParamCreator;
/**
 * FreightAllKindsMappingApi - functional programming interface
 * @export
 */
var FreightAllKindsMappingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FreightAllKindsMappingApiAxiosParamCreator)(configuration);
    return {
        /**
         * Updating existing FAK rows or/and add new ones if not exist.
         * @summary Bulk Upsert
         * @param {Array<CreateFreightAllKindsMapping>} createFreightAllKindsMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpsertRatesFakMappingsBulkPost: function (createFreightAllKindsMapping, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkUpsertRatesFakMappingsBulkPost(createFreightAllKindsMapping, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightAllKindsMappingApi.bulkUpsertRatesFakMappingsBulkPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a new freight all kinds mapping record
         * @summary Create Fak Mapping
         * @param {CreateFreightAllKindsMapping} createFreightAllKindsMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFakMappingRatesFakMappingsPost: function (createFreightAllKindsMapping, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFakMappingRatesFakMappingsPost(createFreightAllKindsMapping, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightAllKindsMappingApi.createFakMappingRatesFakMappingsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a fak record
         * @summary Delete Fak Mapping
         * @param {string} fakId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFakMappingRatesFakMappingsFakIdDelete: function (fakId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteFakMappingRatesFakMappingsFakIdDelete(fakId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightAllKindsMappingApi.deleteFakMappingRatesFakMappingsFakIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Getting all FAK rows by specific query filters.
         * @summary Get All Fak Mappings
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [originalNmfcCode] Filter by original NMFC code.
         * @param {string} [mappedNmfcCode] Filter by mapped FAK code.
         * @param {string} [carrierReferenceQualifier] If set, carrier_reference__value is also required
         * @param {string} [carrierReferenceValue] If set, carrier_reference__qualifier is also required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFakMappingsRatesFakMappingsGet: function (page, limit, originalNmfcCode, mappedNmfcCode, carrierReferenceQualifier, carrierReferenceValue, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllFakMappingsRatesFakMappingsGet(page, limit, originalNmfcCode, mappedNmfcCode, carrierReferenceQualifier, carrierReferenceValue, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightAllKindsMappingApi.getAllFakMappingsRatesFakMappingsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a fak record
         * @summary Get Fak Mapping
         * @param {string} fakId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFakMappingRatesFakMappingsFakIdGet: function (fakId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getFakMappingRatesFakMappingsFakIdGet(fakId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightAllKindsMappingApi.getFakMappingRatesFakMappingsFakIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update a fak record
         * @summary Update Fak Mapping
         * @param {string} fakId
         * @param {CreateFreightAllKindsMapping} createFreightAllKindsMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFakMappingRatesFakMappingsFakIdPut: function (fakId, createFreightAllKindsMapping, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateFakMappingRatesFakMappingsFakIdPut(fakId, createFreightAllKindsMapping, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['FreightAllKindsMappingApi.updateFakMappingRatesFakMappingsFakIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.FreightAllKindsMappingApiFp = FreightAllKindsMappingApiFp;
/**
 * FreightAllKindsMappingApi - factory interface
 * @export
 */
var FreightAllKindsMappingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FreightAllKindsMappingApiFp)(configuration);
    return {
        /**
         * Updating existing FAK rows or/and add new ones if not exist.
         * @summary Bulk Upsert
         * @param {FreightAllKindsMappingApiBulkUpsertRatesFakMappingsBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpsertRatesFakMappingsBulkPost: function (requestParameters, options) {
            return localVarFp.bulkUpsertRatesFakMappingsBulkPost(requestParameters.createFreightAllKindsMapping, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a new freight all kinds mapping record
         * @summary Create Fak Mapping
         * @param {FreightAllKindsMappingApiCreateFakMappingRatesFakMappingsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFakMappingRatesFakMappingsPost: function (requestParameters, options) {
            return localVarFp.createFakMappingRatesFakMappingsPost(requestParameters.createFreightAllKindsMapping, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a fak record
         * @summary Delete Fak Mapping
         * @param {FreightAllKindsMappingApiDeleteFakMappingRatesFakMappingsFakIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFakMappingRatesFakMappingsFakIdDelete: function (requestParameters, options) {
            return localVarFp.deleteFakMappingRatesFakMappingsFakIdDelete(requestParameters.fakId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Getting all FAK rows by specific query filters.
         * @summary Get All Fak Mappings
         * @param {FreightAllKindsMappingApiGetAllFakMappingsRatesFakMappingsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFakMappingsRatesFakMappingsGet: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getAllFakMappingsRatesFakMappingsGet(requestParameters.page, requestParameters.limit, requestParameters.originalNmfcCode, requestParameters.mappedNmfcCode, requestParameters.carrierReferenceQualifier, requestParameters.carrierReferenceValue, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a fak record
         * @summary Get Fak Mapping
         * @param {FreightAllKindsMappingApiGetFakMappingRatesFakMappingsFakIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFakMappingRatesFakMappingsFakIdGet: function (requestParameters, options) {
            return localVarFp.getFakMappingRatesFakMappingsFakIdGet(requestParameters.fakId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a fak record
         * @summary Update Fak Mapping
         * @param {FreightAllKindsMappingApiUpdateFakMappingRatesFakMappingsFakIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFakMappingRatesFakMappingsFakIdPut: function (requestParameters, options) {
            return localVarFp.updateFakMappingRatesFakMappingsFakIdPut(requestParameters.fakId, requestParameters.createFreightAllKindsMapping, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FreightAllKindsMappingApiFactory = FreightAllKindsMappingApiFactory;
/**
 * FreightAllKindsMappingApi - object-oriented interface
 * @export
 * @class FreightAllKindsMappingApi
 * @extends {BaseAPI}
 */
var FreightAllKindsMappingApi = /** @class */ (function (_super) {
    __extends(FreightAllKindsMappingApi, _super);
    function FreightAllKindsMappingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Updating existing FAK rows or/and add new ones if not exist.
     * @summary Bulk Upsert
     * @param {FreightAllKindsMappingApiBulkUpsertRatesFakMappingsBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightAllKindsMappingApi
     */
    FreightAllKindsMappingApi.prototype.bulkUpsertRatesFakMappingsBulkPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightAllKindsMappingApiFp)(this.configuration).bulkUpsertRatesFakMappingsBulkPost(requestParameters.createFreightAllKindsMapping, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a new freight all kinds mapping record
     * @summary Create Fak Mapping
     * @param {FreightAllKindsMappingApiCreateFakMappingRatesFakMappingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightAllKindsMappingApi
     */
    FreightAllKindsMappingApi.prototype.createFakMappingRatesFakMappingsPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightAllKindsMappingApiFp)(this.configuration).createFakMappingRatesFakMappingsPost(requestParameters.createFreightAllKindsMapping, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a fak record
     * @summary Delete Fak Mapping
     * @param {FreightAllKindsMappingApiDeleteFakMappingRatesFakMappingsFakIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightAllKindsMappingApi
     */
    FreightAllKindsMappingApi.prototype.deleteFakMappingRatesFakMappingsFakIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightAllKindsMappingApiFp)(this.configuration).deleteFakMappingRatesFakMappingsFakIdDelete(requestParameters.fakId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Getting all FAK rows by specific query filters.
     * @summary Get All Fak Mappings
     * @param {FreightAllKindsMappingApiGetAllFakMappingsRatesFakMappingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightAllKindsMappingApi
     */
    FreightAllKindsMappingApi.prototype.getAllFakMappingsRatesFakMappingsGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.FreightAllKindsMappingApiFp)(this.configuration).getAllFakMappingsRatesFakMappingsGet(requestParameters.page, requestParameters.limit, requestParameters.originalNmfcCode, requestParameters.mappedNmfcCode, requestParameters.carrierReferenceQualifier, requestParameters.carrierReferenceValue, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a fak record
     * @summary Get Fak Mapping
     * @param {FreightAllKindsMappingApiGetFakMappingRatesFakMappingsFakIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightAllKindsMappingApi
     */
    FreightAllKindsMappingApi.prototype.getFakMappingRatesFakMappingsFakIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightAllKindsMappingApiFp)(this.configuration).getFakMappingRatesFakMappingsFakIdGet(requestParameters.fakId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a fak record
     * @summary Update Fak Mapping
     * @param {FreightAllKindsMappingApiUpdateFakMappingRatesFakMappingsFakIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FreightAllKindsMappingApi
     */
    FreightAllKindsMappingApi.prototype.updateFakMappingRatesFakMappingsFakIdPut = function (requestParameters, options) {
        var _this = this;
        return (0, exports.FreightAllKindsMappingApiFp)(this.configuration).updateFakMappingRatesFakMappingsFakIdPut(requestParameters.fakId, requestParameters.createFreightAllKindsMapping, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FreightAllKindsMappingApi;
}(base_1.BaseAPI));
exports.FreightAllKindsMappingApi = FreightAllKindsMappingApi;
/**
 * PickupsApi - axios parameter creator
 * @export
 */
var PickupsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Pickup Cancellation
         * @param {string} pickupNumber
         * @param {PickupCancellationRequest} pickupCancellationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupCancellationPickupsPickupNumberDelete: function (pickupNumber_1, pickupCancellationRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([pickupNumber_1, pickupCancellationRequest_1], args_1, true), void 0, function (pickupNumber, pickupCancellationRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'pickupNumber' is not null or undefined
                            (0, common_1.assertParamExists)('pickupCancellationPickupsPickupNumberDelete', 'pickupNumber', pickupNumber);
                            // verify required parameter 'pickupCancellationRequest' is not null or undefined
                            (0, common_1.assertParamExists)('pickupCancellationPickupsPickupNumberDelete', 'pickupCancellationRequest', pickupCancellationRequest);
                            localVarPath = "/pickups/{pickup_number}"
                                .replace("{".concat("pickup_number", "}"), encodeURIComponent(String(pickupNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pickupCancellationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Pickups
         * @param {PickupRequest} pickupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsPickupsPost: function (pickupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([pickupRequest_1], args_1, true), void 0, function (pickupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'pickupRequest' is not null or undefined
                            (0, common_1.assertParamExists)('pickupsPickupsPost', 'pickupRequest', pickupRequest);
                            localVarPath = "/pickups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pickupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PickupsApiAxiosParamCreator = PickupsApiAxiosParamCreator;
/**
 * PickupsApi - functional programming interface
 * @export
 */
var PickupsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PickupsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Pickup Cancellation
         * @param {string} pickupNumber
         * @param {PickupCancellationRequest} pickupCancellationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupCancellationPickupsPickupNumberDelete: function (pickupNumber, pickupCancellationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pickupCancellationPickupsPickupNumberDelete(pickupNumber, pickupCancellationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PickupsApi.pickupCancellationPickupsPickupNumberDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Pickups
         * @param {PickupRequest} pickupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsPickupsPost: function (pickupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pickupsPickupsPost(pickupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['PickupsApi.pickupsPickupsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.PickupsApiFp = PickupsApiFp;
/**
 * PickupsApi - factory interface
 * @export
 */
var PickupsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PickupsApiFp)(configuration);
    return {
        /**
         *
         * @summary Pickup Cancellation
         * @param {PickupsApiPickupCancellationPickupsPickupNumberDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupCancellationPickupsPickupNumberDelete: function (requestParameters, options) {
            return localVarFp.pickupCancellationPickupsPickupNumberDelete(requestParameters.pickupNumber, requestParameters.pickupCancellationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Pickups
         * @param {PickupsApiPickupsPickupsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsPickupsPost: function (requestParameters, options) {
            return localVarFp.pickupsPickupsPost(requestParameters.pickupRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PickupsApiFactory = PickupsApiFactory;
/**
 * PickupsApi - object-oriented interface
 * @export
 * @class PickupsApi
 * @extends {BaseAPI}
 */
var PickupsApi = /** @class */ (function (_super) {
    __extends(PickupsApi, _super);
    function PickupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Pickup Cancellation
     * @param {PickupsApiPickupCancellationPickupsPickupNumberDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickupsApi
     */
    PickupsApi.prototype.pickupCancellationPickupsPickupNumberDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PickupsApiFp)(this.configuration).pickupCancellationPickupsPickupNumberDelete(requestParameters.pickupNumber, requestParameters.pickupCancellationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Pickups
     * @param {PickupsApiPickupsPickupsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PickupsApi
     */
    PickupsApi.prototype.pickupsPickupsPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.PickupsApiFp)(this.configuration).pickupsPickupsPost(requestParameters.pickupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PickupsApi;
}(base_1.BaseAPI));
exports.PickupsApi = PickupsApi;
/**
 * ProvidersApi - axios parameter creator
 * @export
 */
var ProvidersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Add an account to capacity provider for a tenant.
         * @param {ProviderCode} providerCode
         * @param {CreateCapacityProviderAccountRequestPayloadSchema} createCapacityProviderAccountRequestPayloadSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProviderAccountProvidersProviderCodePost: function (providerCode_1, createCapacityProviderAccountRequestPayloadSchema_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([providerCode_1, createCapacityProviderAccountRequestPayloadSchema_1], args_1, true), void 0, function (providerCode, createCapacityProviderAccountRequestPayloadSchema, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'providerCode' is not null or undefined
                            (0, common_1.assertParamExists)('addProviderAccountProvidersProviderCodePost', 'providerCode', providerCode);
                            // verify required parameter 'createCapacityProviderAccountRequestPayloadSchema' is not null or undefined
                            (0, common_1.assertParamExists)('addProviderAccountProvidersProviderCodePost', 'createCapacityProviderAccountRequestPayloadSchema', createCapacityProviderAccountRequestPayloadSchema);
                            localVarPath = "/providers/{provider_code}"
                                .replace("{".concat("provider_code", "}"), encodeURIComponent(String(providerCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCapacityProviderAccountRequestPayloadSchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add a new capacity provider to a tenant.
         * @param {CreateCapacityProviderSchema} createCapacityProviderSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderProvidersPost: function (createCapacityProviderSchema_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createCapacityProviderSchema_1], args_1, true), void 0, function (createCapacityProviderSchema, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createCapacityProviderSchema' is not null or undefined
                            (0, common_1.assertParamExists)('createProviderProvidersPost', 'createCapacityProviderSchema', createCapacityProviderSchema);
                            localVarPath = "/providers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCapacityProviderSchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Provider Account
         * @param {ProviderCode} providerCode
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProviderAccountProvidersProviderCodeIdDelete: function (providerCode_1, id_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([providerCode_1, id_1], args_1, true), void 0, function (providerCode, id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'providerCode' is not null or undefined
                            (0, common_1.assertParamExists)('deleteProviderAccountProvidersProviderCodeIdDelete', 'providerCode', providerCode);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteProviderAccountProvidersProviderCodeIdDelete', 'id', id);
                            localVarPath = "/providers/{provider_code}/{id}"
                                .replace("{".concat("provider_code", "}"), encodeURIComponent(String(providerCode)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Removes a capacity provider and all its associated accounts from a tenant.
         * @summary Remove a capacity provider from account.
         * @param {ProviderCode} providerCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProviderProvidersProviderCodeDelete: function (providerCode_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([providerCode_1], args_1, true), void 0, function (providerCode, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'providerCode' is not null or undefined
                            (0, common_1.assertParamExists)('deleteProviderProvidersProviderCodeDelete', 'providerCode', providerCode);
                            localVarPath = "/providers/{provider_code}"
                                .replace("{".concat("provider_code", "}"), encodeURIComponent(String(providerCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Gets all capacity providers and their associated accounts grouped by provider_code.
         * @summary Gets all tenant capacity providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProvidersProvidersGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/providers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Getting an account by ID is specific to the provider. Each provider may have a different alias for their identifier. example: account_number for uber would be used as the \"id\" in the request path.
         * @summary Get individual capacity provider, account for a tenant.
         * @param {ProviderCode} providerCode
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAccountProvidersProviderCodeIdGet: function (providerCode_1, id_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([providerCode_1, id_1], args_1, true), void 0, function (providerCode, id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'providerCode' is not null or undefined
                            (0, common_1.assertParamExists)('getProviderAccountProvidersProviderCodeIdGet', 'providerCode', providerCode);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getProviderAccountProvidersProviderCodeIdGet', 'id', id);
                            localVarPath = "/providers/{provider_code}/{id}"
                                .replace("{".concat("provider_code", "}"), encodeURIComponent(String(providerCode)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Gets a capacity provider for a tenant, and all its associated accounts.
         * @summary Get a capacity provider.
         * @param {ProviderCode} providerCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderProvidersProviderCodeGet: function (providerCode_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([providerCode_1], args_1, true), void 0, function (providerCode, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'providerCode' is not null or undefined
                            (0, common_1.assertParamExists)('getProviderProvidersProviderCodeGet', 'providerCode', providerCode);
                            localVarPath = "/providers/{provider_code}"
                                .replace("{".concat("provider_code", "}"), encodeURIComponent(String(providerCode)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an existing account for a capacity provider of a tenant.
         * @param {ProviderCode} providerCode
         * @param {string} accountId
         * @param {CreateCapacityProviderAccountRequestPayloadSchema} createCapacityProviderAccountRequestPayloadSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderAccountProvidersProviderCodeAccountIdPut: function (providerCode_1, accountId_1, createCapacityProviderAccountRequestPayloadSchema_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([providerCode_1, accountId_1, createCapacityProviderAccountRequestPayloadSchema_1], args_1, true), void 0, function (providerCode, accountId, createCapacityProviderAccountRequestPayloadSchema, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'providerCode' is not null or undefined
                            (0, common_1.assertParamExists)('updateProviderAccountProvidersProviderCodeAccountIdPut', 'providerCode', providerCode);
                            // verify required parameter 'accountId' is not null or undefined
                            (0, common_1.assertParamExists)('updateProviderAccountProvidersProviderCodeAccountIdPut', 'accountId', accountId);
                            // verify required parameter 'createCapacityProviderAccountRequestPayloadSchema' is not null or undefined
                            (0, common_1.assertParamExists)('updateProviderAccountProvidersProviderCodeAccountIdPut', 'createCapacityProviderAccountRequestPayloadSchema', createCapacityProviderAccountRequestPayloadSchema);
                            localVarPath = "/providers/{provider_code}/{account_id}"
                                .replace("{".concat("provider_code", "}"), encodeURIComponent(String(providerCode)))
                                .replace("{".concat("account_id", "}"), encodeURIComponent(String(accountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCapacityProviderAccountRequestPayloadSchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a capacity provider to a tenant.
         * @param {CreateCapacityProviderSchema} createCapacityProviderSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderProvidersPut: function (createCapacityProviderSchema_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createCapacityProviderSchema_1], args_1, true), void 0, function (createCapacityProviderSchema, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createCapacityProviderSchema' is not null or undefined
                            (0, common_1.assertParamExists)('updateProviderProvidersPut', 'createCapacityProviderSchema', createCapacityProviderSchema);
                            localVarPath = "/providers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCapacityProviderSchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ProvidersApiAxiosParamCreator = ProvidersApiAxiosParamCreator;
/**
 * ProvidersApi - functional programming interface
 * @export
 */
var ProvidersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ProvidersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Add an account to capacity provider for a tenant.
         * @param {ProviderCode} providerCode
         * @param {CreateCapacityProviderAccountRequestPayloadSchema} createCapacityProviderAccountRequestPayloadSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProviderAccountProvidersProviderCodePost: function (providerCode, createCapacityProviderAccountRequestPayloadSchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addProviderAccountProvidersProviderCodePost(providerCode, createCapacityProviderAccountRequestPayloadSchema, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProvidersApi.addProviderAccountProvidersProviderCodePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add a new capacity provider to a tenant.
         * @param {CreateCapacityProviderSchema} createCapacityProviderSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderProvidersPost: function (createCapacityProviderSchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createProviderProvidersPost(createCapacityProviderSchema, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProvidersApi.createProviderProvidersPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Provider Account
         * @param {ProviderCode} providerCode
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProviderAccountProvidersProviderCodeIdDelete: function (providerCode, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteProviderAccountProvidersProviderCodeIdDelete(providerCode, id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProvidersApi.deleteProviderAccountProvidersProviderCodeIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Removes a capacity provider and all its associated accounts from a tenant.
         * @summary Remove a capacity provider from account.
         * @param {ProviderCode} providerCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProviderProvidersProviderCodeDelete: function (providerCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteProviderProvidersProviderCodeDelete(providerCode, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProvidersApi.deleteProviderProvidersProviderCodeDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Gets all capacity providers and their associated accounts grouped by provider_code.
         * @summary Gets all tenant capacity providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProvidersProvidersGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllProvidersProvidersGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProvidersApi.getAllProvidersProvidersGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Getting an account by ID is specific to the provider. Each provider may have a different alias for their identifier. example: account_number for uber would be used as the \"id\" in the request path.
         * @summary Get individual capacity provider, account for a tenant.
         * @param {ProviderCode} providerCode
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAccountProvidersProviderCodeIdGet: function (providerCode, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProviderAccountProvidersProviderCodeIdGet(providerCode, id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProvidersApi.getProviderAccountProvidersProviderCodeIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Gets a capacity provider for a tenant, and all its associated accounts.
         * @summary Get a capacity provider.
         * @param {ProviderCode} providerCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderProvidersProviderCodeGet: function (providerCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProviderProvidersProviderCodeGet(providerCode, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProvidersApi.getProviderProvidersProviderCodeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an existing account for a capacity provider of a tenant.
         * @param {ProviderCode} providerCode
         * @param {string} accountId
         * @param {CreateCapacityProviderAccountRequestPayloadSchema} createCapacityProviderAccountRequestPayloadSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderAccountProvidersProviderCodeAccountIdPut: function (providerCode, accountId, createCapacityProviderAccountRequestPayloadSchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateProviderAccountProvidersProviderCodeAccountIdPut(providerCode, accountId, createCapacityProviderAccountRequestPayloadSchema, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProvidersApi.updateProviderAccountProvidersProviderCodeAccountIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a capacity provider to a tenant.
         * @param {CreateCapacityProviderSchema} createCapacityProviderSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderProvidersPut: function (createCapacityProviderSchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateProviderProvidersPut(createCapacityProviderSchema, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProvidersApi.updateProviderProvidersPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ProvidersApiFp = ProvidersApiFp;
/**
 * ProvidersApi - factory interface
 * @export
 */
var ProvidersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ProvidersApiFp)(configuration);
    return {
        /**
         *
         * @summary Add an account to capacity provider for a tenant.
         * @param {ProvidersApiAddProviderAccountProvidersProviderCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProviderAccountProvidersProviderCodePost: function (requestParameters, options) {
            return localVarFp.addProviderAccountProvidersProviderCodePost(requestParameters.providerCode, requestParameters.createCapacityProviderAccountRequestPayloadSchema, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add a new capacity provider to a tenant.
         * @param {ProvidersApiCreateProviderProvidersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProviderProvidersPost: function (requestParameters, options) {
            return localVarFp.createProviderProvidersPost(requestParameters.createCapacityProviderSchema, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Provider Account
         * @param {ProvidersApiDeleteProviderAccountProvidersProviderCodeIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProviderAccountProvidersProviderCodeIdDelete: function (requestParameters, options) {
            return localVarFp.deleteProviderAccountProvidersProviderCodeIdDelete(requestParameters.providerCode, requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Removes a capacity provider and all its associated accounts from a tenant.
         * @summary Remove a capacity provider from account.
         * @param {ProvidersApiDeleteProviderProvidersProviderCodeDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProviderProvidersProviderCodeDelete: function (requestParameters, options) {
            return localVarFp.deleteProviderProvidersProviderCodeDelete(requestParameters.providerCode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets all capacity providers and their associated accounts grouped by provider_code.
         * @summary Gets all tenant capacity providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProvidersProvidersGet: function (options) {
            return localVarFp.getAllProvidersProvidersGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Getting an account by ID is specific to the provider. Each provider may have a different alias for their identifier. example: account_number for uber would be used as the \"id\" in the request path.
         * @summary Get individual capacity provider, account for a tenant.
         * @param {ProvidersApiGetProviderAccountProvidersProviderCodeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderAccountProvidersProviderCodeIdGet: function (requestParameters, options) {
            return localVarFp.getProviderAccountProvidersProviderCodeIdGet(requestParameters.providerCode, requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets a capacity provider for a tenant, and all its associated accounts.
         * @summary Get a capacity provider.
         * @param {ProvidersApiGetProviderProvidersProviderCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderProvidersProviderCodeGet: function (requestParameters, options) {
            return localVarFp.getProviderProvidersProviderCodeGet(requestParameters.providerCode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an existing account for a capacity provider of a tenant.
         * @param {ProvidersApiUpdateProviderAccountProvidersProviderCodeAccountIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderAccountProvidersProviderCodeAccountIdPut: function (requestParameters, options) {
            return localVarFp.updateProviderAccountProvidersProviderCodeAccountIdPut(requestParameters.providerCode, requestParameters.accountId, requestParameters.createCapacityProviderAccountRequestPayloadSchema, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a capacity provider to a tenant.
         * @param {ProvidersApiUpdateProviderProvidersPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProviderProvidersPut: function (requestParameters, options) {
            return localVarFp.updateProviderProvidersPut(requestParameters.createCapacityProviderSchema, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ProvidersApiFactory = ProvidersApiFactory;
/**
 * ProvidersApi - object-oriented interface
 * @export
 * @class ProvidersApi
 * @extends {BaseAPI}
 */
var ProvidersApi = /** @class */ (function (_super) {
    __extends(ProvidersApi, _super);
    function ProvidersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Add an account to capacity provider for a tenant.
     * @param {ProvidersApiAddProviderAccountProvidersProviderCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    ProvidersApi.prototype.addProviderAccountProvidersProviderCodePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProvidersApiFp)(this.configuration).addProviderAccountProvidersProviderCodePost(requestParameters.providerCode, requestParameters.createCapacityProviderAccountRequestPayloadSchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add a new capacity provider to a tenant.
     * @param {ProvidersApiCreateProviderProvidersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    ProvidersApi.prototype.createProviderProvidersPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProvidersApiFp)(this.configuration).createProviderProvidersPost(requestParameters.createCapacityProviderSchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Provider Account
     * @param {ProvidersApiDeleteProviderAccountProvidersProviderCodeIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    ProvidersApi.prototype.deleteProviderAccountProvidersProviderCodeIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProvidersApiFp)(this.configuration).deleteProviderAccountProvidersProviderCodeIdDelete(requestParameters.providerCode, requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Removes a capacity provider and all its associated accounts from a tenant.
     * @summary Remove a capacity provider from account.
     * @param {ProvidersApiDeleteProviderProvidersProviderCodeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    ProvidersApi.prototype.deleteProviderProvidersProviderCodeDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProvidersApiFp)(this.configuration).deleteProviderProvidersProviderCodeDelete(requestParameters.providerCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets all capacity providers and their associated accounts grouped by provider_code.
     * @summary Gets all tenant capacity providers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    ProvidersApi.prototype.getAllProvidersProvidersGet = function (options) {
        var _this = this;
        return (0, exports.ProvidersApiFp)(this.configuration).getAllProvidersProvidersGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Getting an account by ID is specific to the provider. Each provider may have a different alias for their identifier. example: account_number for uber would be used as the \"id\" in the request path.
     * @summary Get individual capacity provider, account for a tenant.
     * @param {ProvidersApiGetProviderAccountProvidersProviderCodeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    ProvidersApi.prototype.getProviderAccountProvidersProviderCodeIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProvidersApiFp)(this.configuration).getProviderAccountProvidersProviderCodeIdGet(requestParameters.providerCode, requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets a capacity provider for a tenant, and all its associated accounts.
     * @summary Get a capacity provider.
     * @param {ProvidersApiGetProviderProvidersProviderCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    ProvidersApi.prototype.getProviderProvidersProviderCodeGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProvidersApiFp)(this.configuration).getProviderProvidersProviderCodeGet(requestParameters.providerCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an existing account for a capacity provider of a tenant.
     * @param {ProvidersApiUpdateProviderAccountProvidersProviderCodeAccountIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    ProvidersApi.prototype.updateProviderAccountProvidersProviderCodeAccountIdPut = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProvidersApiFp)(this.configuration).updateProviderAccountProvidersProviderCodeAccountIdPut(requestParameters.providerCode, requestParameters.accountId, requestParameters.createCapacityProviderAccountRequestPayloadSchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a capacity provider to a tenant.
     * @param {ProvidersApiUpdateProviderProvidersPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    ProvidersApi.prototype.updateProviderProvidersPut = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProvidersApiFp)(this.configuration).updateProviderProvidersPut(requestParameters.createCapacityProviderSchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProvidersApi;
}(base_1.BaseAPI));
exports.ProvidersApi = ProvidersApi;
/**
 * RateTablesApi - axios parameter creator
 * @export
 */
var RateTablesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Replaces all existing rates with new ones.
         * @summary Bulk Replace Rows
         * @param {string} rateTableId
         * @param {Array<CreateRateTableRow>} createRateTableRow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkReplaceRowsRatesRateTablesRateTableIdRowsPut: function (rateTableId_1, createRateTableRow_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateTableId_1, createRateTableRow_1], args_1, true), void 0, function (rateTableId, createRateTableRow, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateTableId' is not null or undefined
                            (0, common_1.assertParamExists)('bulkReplaceRowsRatesRateTablesRateTableIdRowsPut', 'rateTableId', rateTableId);
                            // verify required parameter 'createRateTableRow' is not null or undefined
                            (0, common_1.assertParamExists)('bulkReplaceRowsRatesRateTablesRateTableIdRowsPut', 'createRateTableRow', createRateTableRow);
                            localVarPath = "/rates/rate-tables/{rate_table_id}/rows"
                                .replace("{".concat("rate_table_id", "}"), encodeURIComponent(String(rateTableId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createRateTableRow, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a new rate table
         * @summary Create Rate Table
         * @param {CreateRateTable} createRateTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateTableRatesRateTablesPost: function (createRateTable_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createRateTable_1], args_1, true), void 0, function (createRateTable, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createRateTable' is not null or undefined
                            (0, common_1.assertParamExists)('createRateTableRatesRateTablesPost', 'createRateTable', createRateTable);
                            localVarPath = "/rates/rate-tables";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createRateTable, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Creates a single row within a rate table
         * @summary Create Rate Table Row
         * @param {string} rateTableId
         * @param {CreateRateTableRow} createRateTableRow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateTableRowRatesRateTablesRateTableIdRowsPost: function (rateTableId_1, createRateTableRow_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateTableId_1, createRateTableRow_1], args_1, true), void 0, function (rateTableId, createRateTableRow, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateTableId' is not null or undefined
                            (0, common_1.assertParamExists)('createRateTableRowRatesRateTablesRateTableIdRowsPost', 'rateTableId', rateTableId);
                            // verify required parameter 'createRateTableRow' is not null or undefined
                            (0, common_1.assertParamExists)('createRateTableRowRatesRateTablesRateTableIdRowsPost', 'createRateTableRow', createRateTableRow);
                            localVarPath = "/rates/rate-tables/{rate_table_id}/rows"
                                .replace("{".concat("rate_table_id", "}"), encodeURIComponent(String(rateTableId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createRateTableRow, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Rate Table
         * @param {string} rateTableId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRateTableRatesRateTablesRateTableIdDelete: function (rateTableId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateTableId_1], args_1, true), void 0, function (rateTableId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateTableId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRateTableRatesRateTablesRateTableIdDelete', 'rateTableId', rateTableId);
                            localVarPath = "/rates/rate-tables/{rate_table_id}"
                                .replace("{".concat("rate_table_id", "}"), encodeURIComponent(String(rateTableId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Rate Table Row
         * @param {string} rateTableId
         * @param {string} rowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRateTableRowRatesRateTablesRateTableIdRowsRowIdDelete: function (rateTableId_1, rowId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateTableId_1, rowId_1], args_1, true), void 0, function (rateTableId, rowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateTableId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRateTableRowRatesRateTablesRateTableIdRowsRowIdDelete', 'rateTableId', rateTableId);
                            // verify required parameter 'rowId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteRateTableRowRatesRateTablesRateTableIdRowsRowIdDelete', 'rowId', rowId);
                            localVarPath = "/rates/rate-tables/{rate_table_id}/rows/{row_id}"
                                .replace("{".concat("rate_table_id", "}"), encodeURIComponent(String(rateTableId)))
                                .replace("{".concat("row_id", "}"), encodeURIComponent(String(rowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all configured rate tables of varying types
         * @summary Get All Rate Tables
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [serviceLevel] Filter by service level
         * @param {string} [carrierReferenceQualifier] If set, carrier_reference__value is also required
         * @param {string} [carrierReferenceValue] If set, carrier_reference__qualifier is also required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRateTablesRatesRateTablesGet: function (page_1, limit_1, serviceLevel_1, carrierReferenceQualifier_1, carrierReferenceValue_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, limit_1, serviceLevel_1, carrierReferenceQualifier_1, carrierReferenceValue_1], args_1, true), void 0, function (page, limit, serviceLevel, carrierReferenceQualifier, carrierReferenceValue, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/rates/rate-tables";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (serviceLevel !== undefined) {
                                localVarQueryParameter['service_level'] = serviceLevel;
                            }
                            if (carrierReferenceQualifier !== undefined) {
                                localVarQueryParameter['carrier_reference__qualifier'] = carrierReferenceQualifier;
                            }
                            if (carrierReferenceValue !== undefined) {
                                localVarQueryParameter['carrier_reference__value'] = carrierReferenceValue;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Applicable Rates
         * @param {RateTableQuery} rateTableQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicableRatesRatesRateTablesQueryPost: function (rateTableQuery_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateTableQuery_1], args_1, true), void 0, function (rateTableQuery, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateTableQuery' is not null or undefined
                            (0, common_1.assertParamExists)('getApplicableRatesRatesRateTablesQueryPost', 'rateTableQuery', rateTableQuery);
                            localVarPath = "/rates/rate-tables/query";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rateTableQuery, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rate Table
         * @param {string} rateTableId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableRatesRateTablesRateTableIdGet: function (rateTableId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateTableId_1], args_1, true), void 0, function (rateTableId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateTableId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateTableRatesRateTablesRateTableIdGet', 'rateTableId', rateTableId);
                            localVarPath = "/rates/rate-tables/{rate_table_id}"
                                .replace("{".concat("rate_table_id", "}"), encodeURIComponent(String(rateTableId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rate Table Row
         * @param {string} rateTableId
         * @param {string} rowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableRowRatesRateTablesRateTableIdRowsRowIdGet: function (rateTableId_1, rowId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateTableId_1, rowId_1], args_1, true), void 0, function (rateTableId, rowId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateTableId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateTableRowRatesRateTablesRateTableIdRowsRowIdGet', 'rateTableId', rateTableId);
                            // verify required parameter 'rowId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateTableRowRatesRateTablesRateTableIdRowsRowIdGet', 'rowId', rowId);
                            localVarPath = "/rates/rate-tables/{rate_table_id}/rows/{row_id}"
                                .replace("{".concat("rate_table_id", "}"), encodeURIComponent(String(rateTableId)))
                                .replace("{".concat("row_id", "}"), encodeURIComponent(String(rowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rate Table Rows
         * @param {string} rateTableId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableRowsRatesRateTablesRateTableIdRowsGet: function (rateTableId_1, page_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateTableId_1, page_1, limit_1], args_1, true), void 0, function (rateTableId, page, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateTableId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateTableRowsRatesRateTablesRateTableIdRowsGet', 'rateTableId', rateTableId);
                            localVarPath = "/rates/rate-tables/{rate_table_id}/rows"
                                .replace("{".concat("rate_table_id", "}"), encodeURIComponent(String(rateTableId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Rate Table
         * @param {string} rateTableId
         * @param {UpdateRateTable} updateRateTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRateTableRatesRateTablesRateTableIdPut: function (rateTableId_1, updateRateTable_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateTableId_1, updateRateTable_1], args_1, true), void 0, function (rateTableId, updateRateTable, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateTableId' is not null or undefined
                            (0, common_1.assertParamExists)('updateRateTableRatesRateTablesRateTableIdPut', 'rateTableId', rateTableId);
                            // verify required parameter 'updateRateTable' is not null or undefined
                            (0, common_1.assertParamExists)('updateRateTableRatesRateTablesRateTableIdPut', 'updateRateTable', updateRateTable);
                            localVarPath = "/rates/rate-tables/{rate_table_id}"
                                .replace("{".concat("rate_table_id", "}"), encodeURIComponent(String(rateTableId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateRateTable, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RateTablesApiAxiosParamCreator = RateTablesApiAxiosParamCreator;
/**
 * RateTablesApi - functional programming interface
 * @export
 */
var RateTablesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RateTablesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Replaces all existing rates with new ones.
         * @summary Bulk Replace Rows
         * @param {string} rateTableId
         * @param {Array<CreateRateTableRow>} createRateTableRow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkReplaceRowsRatesRateTablesRateTableIdRowsPut: function (rateTableId, createRateTableRow, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.bulkReplaceRowsRatesRateTablesRateTableIdRowsPut(rateTableId, createRateTableRow, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTablesApi.bulkReplaceRowsRatesRateTablesRateTableIdRowsPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a new rate table
         * @summary Create Rate Table
         * @param {CreateRateTable} createRateTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateTableRatesRateTablesPost: function (createRateTable, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRateTableRatesRateTablesPost(createRateTable, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTablesApi.createRateTableRatesRateTablesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Creates a single row within a rate table
         * @summary Create Rate Table Row
         * @param {string} rateTableId
         * @param {CreateRateTableRow} createRateTableRow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateTableRowRatesRateTablesRateTableIdRowsPost: function (rateTableId, createRateTableRow, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRateTableRowRatesRateTablesRateTableIdRowsPost(rateTableId, createRateTableRow, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTablesApi.createRateTableRowRatesRateTablesRateTableIdRowsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Rate Table
         * @param {string} rateTableId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRateTableRatesRateTablesRateTableIdDelete: function (rateTableId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRateTableRatesRateTablesRateTableIdDelete(rateTableId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTablesApi.deleteRateTableRatesRateTablesRateTableIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete Rate Table Row
         * @param {string} rateTableId
         * @param {string} rowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRateTableRowRatesRateTablesRateTableIdRowsRowIdDelete: function (rateTableId, rowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRateTableRowRatesRateTablesRateTableIdRowsRowIdDelete(rateTableId, rowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTablesApi.deleteRateTableRowRatesRateTablesRateTableIdRowsRowIdDelete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get all configured rate tables of varying types
         * @summary Get All Rate Tables
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [serviceLevel] Filter by service level
         * @param {string} [carrierReferenceQualifier] If set, carrier_reference__value is also required
         * @param {string} [carrierReferenceValue] If set, carrier_reference__qualifier is also required
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRateTablesRatesRateTablesGet: function (page, limit, serviceLevel, carrierReferenceQualifier, carrierReferenceValue, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllRateTablesRatesRateTablesGet(page, limit, serviceLevel, carrierReferenceQualifier, carrierReferenceValue, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTablesApi.getAllRateTablesRatesRateTablesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Applicable Rates
         * @param {RateTableQuery} rateTableQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicableRatesRatesRateTablesQueryPost: function (rateTableQuery, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getApplicableRatesRatesRateTablesQueryPost(rateTableQuery, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTablesApi.getApplicableRatesRatesRateTablesQueryPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rate Table
         * @param {string} rateTableId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableRatesRateTablesRateTableIdGet: function (rateTableId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateTableRatesRateTablesRateTableIdGet(rateTableId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTablesApi.getRateTableRatesRateTablesRateTableIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rate Table Row
         * @param {string} rateTableId
         * @param {string} rowId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableRowRatesRateTablesRateTableIdRowsRowIdGet: function (rateTableId, rowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateTableRowRatesRateTablesRateTableIdRowsRowIdGet(rateTableId, rowId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTablesApi.getRateTableRowRatesRateTablesRateTableIdRowsRowIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rate Table Rows
         * @param {string} rateTableId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableRowsRatesRateTablesRateTableIdRowsGet: function (rateTableId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateTableRowsRatesRateTablesRateTableIdRowsGet(rateTableId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTablesApi.getRateTableRowsRatesRateTablesRateTableIdRowsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Rate Table
         * @param {string} rateTableId
         * @param {UpdateRateTable} updateRateTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRateTableRatesRateTablesRateTableIdPut: function (rateTableId, updateRateTable, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateRateTableRatesRateTablesRateTableIdPut(rateTableId, updateRateTable, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RateTablesApi.updateRateTableRatesRateTablesRateTableIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RateTablesApiFp = RateTablesApiFp;
/**
 * RateTablesApi - factory interface
 * @export
 */
var RateTablesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RateTablesApiFp)(configuration);
    return {
        /**
         * Replaces all existing rates with new ones.
         * @summary Bulk Replace Rows
         * @param {RateTablesApiBulkReplaceRowsRatesRateTablesRateTableIdRowsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkReplaceRowsRatesRateTablesRateTableIdRowsPut: function (requestParameters, options) {
            return localVarFp.bulkReplaceRowsRatesRateTablesRateTableIdRowsPut(requestParameters.rateTableId, requestParameters.createRateTableRow, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a new rate table
         * @summary Create Rate Table
         * @param {RateTablesApiCreateRateTableRatesRateTablesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateTableRatesRateTablesPost: function (requestParameters, options) {
            return localVarFp.createRateTableRatesRateTablesPost(requestParameters.createRateTable, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Creates a single row within a rate table
         * @summary Create Rate Table Row
         * @param {RateTablesApiCreateRateTableRowRatesRateTablesRateTableIdRowsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateTableRowRatesRateTablesRateTableIdRowsPost: function (requestParameters, options) {
            return localVarFp.createRateTableRowRatesRateTablesRateTableIdRowsPost(requestParameters.rateTableId, requestParameters.createRateTableRow, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Rate Table
         * @param {RateTablesApiDeleteRateTableRatesRateTablesRateTableIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRateTableRatesRateTablesRateTableIdDelete: function (requestParameters, options) {
            return localVarFp.deleteRateTableRatesRateTablesRateTableIdDelete(requestParameters.rateTableId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete Rate Table Row
         * @param {RateTablesApiDeleteRateTableRowRatesRateTablesRateTableIdRowsRowIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRateTableRowRatesRateTablesRateTableIdRowsRowIdDelete: function (requestParameters, options) {
            return localVarFp.deleteRateTableRowRatesRateTablesRateTableIdRowsRowIdDelete(requestParameters.rateTableId, requestParameters.rowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all configured rate tables of varying types
         * @summary Get All Rate Tables
         * @param {RateTablesApiGetAllRateTablesRatesRateTablesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRateTablesRatesRateTablesGet: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getAllRateTablesRatesRateTablesGet(requestParameters.page, requestParameters.limit, requestParameters.serviceLevel, requestParameters.carrierReferenceQualifier, requestParameters.carrierReferenceValue, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Applicable Rates
         * @param {RateTablesApiGetApplicableRatesRatesRateTablesQueryPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicableRatesRatesRateTablesQueryPost: function (requestParameters, options) {
            return localVarFp.getApplicableRatesRatesRateTablesQueryPost(requestParameters.rateTableQuery, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Rate Table
         * @param {RateTablesApiGetRateTableRatesRateTablesRateTableIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableRatesRateTablesRateTableIdGet: function (requestParameters, options) {
            return localVarFp.getRateTableRatesRateTablesRateTableIdGet(requestParameters.rateTableId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Rate Table Row
         * @param {RateTablesApiGetRateTableRowRatesRateTablesRateTableIdRowsRowIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableRowRatesRateTablesRateTableIdRowsRowIdGet: function (requestParameters, options) {
            return localVarFp.getRateTableRowRatesRateTablesRateTableIdRowsRowIdGet(requestParameters.rateTableId, requestParameters.rowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Rate Table Rows
         * @param {RateTablesApiGetRateTableRowsRatesRateTablesRateTableIdRowsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableRowsRatesRateTablesRateTableIdRowsGet: function (requestParameters, options) {
            return localVarFp.getRateTableRowsRatesRateTablesRateTableIdRowsGet(requestParameters.rateTableId, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Rate Table
         * @param {RateTablesApiUpdateRateTableRatesRateTablesRateTableIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRateTableRatesRateTablesRateTableIdPut: function (requestParameters, options) {
            return localVarFp.updateRateTableRatesRateTablesRateTableIdPut(requestParameters.rateTableId, requestParameters.updateRateTable, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RateTablesApiFactory = RateTablesApiFactory;
/**
 * RateTablesApi - object-oriented interface
 * @export
 * @class RateTablesApi
 * @extends {BaseAPI}
 */
var RateTablesApi = /** @class */ (function (_super) {
    __extends(RateTablesApi, _super);
    function RateTablesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Replaces all existing rates with new ones.
     * @summary Bulk Replace Rows
     * @param {RateTablesApiBulkReplaceRowsRatesRateTablesRateTableIdRowsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.bulkReplaceRowsRatesRateTablesRateTableIdRowsPut = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).bulkReplaceRowsRatesRateTablesRateTableIdRowsPut(requestParameters.rateTableId, requestParameters.createRateTableRow, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a new rate table
     * @summary Create Rate Table
     * @param {RateTablesApiCreateRateTableRatesRateTablesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.createRateTableRatesRateTablesPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).createRateTableRatesRateTablesPost(requestParameters.createRateTable, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Creates a single row within a rate table
     * @summary Create Rate Table Row
     * @param {RateTablesApiCreateRateTableRowRatesRateTablesRateTableIdRowsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.createRateTableRowRatesRateTablesRateTableIdRowsPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).createRateTableRowRatesRateTablesRateTableIdRowsPost(requestParameters.rateTableId, requestParameters.createRateTableRow, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Rate Table
     * @param {RateTablesApiDeleteRateTableRatesRateTablesRateTableIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.deleteRateTableRatesRateTablesRateTableIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).deleteRateTableRatesRateTablesRateTableIdDelete(requestParameters.rateTableId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete Rate Table Row
     * @param {RateTablesApiDeleteRateTableRowRatesRateTablesRateTableIdRowsRowIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.deleteRateTableRowRatesRateTablesRateTableIdRowsRowIdDelete = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).deleteRateTableRowRatesRateTablesRateTableIdRowsRowIdDelete(requestParameters.rateTableId, requestParameters.rowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all configured rate tables of varying types
     * @summary Get All Rate Tables
     * @param {RateTablesApiGetAllRateTablesRatesRateTablesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.getAllRateTablesRatesRateTablesGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.RateTablesApiFp)(this.configuration).getAllRateTablesRatesRateTablesGet(requestParameters.page, requestParameters.limit, requestParameters.serviceLevel, requestParameters.carrierReferenceQualifier, requestParameters.carrierReferenceValue, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Applicable Rates
     * @param {RateTablesApiGetApplicableRatesRatesRateTablesQueryPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.getApplicableRatesRatesRateTablesQueryPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).getApplicableRatesRatesRateTablesQueryPost(requestParameters.rateTableQuery, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Rate Table
     * @param {RateTablesApiGetRateTableRatesRateTablesRateTableIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.getRateTableRatesRateTablesRateTableIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).getRateTableRatesRateTablesRateTableIdGet(requestParameters.rateTableId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Rate Table Row
     * @param {RateTablesApiGetRateTableRowRatesRateTablesRateTableIdRowsRowIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.getRateTableRowRatesRateTablesRateTableIdRowsRowIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).getRateTableRowRatesRateTablesRateTableIdRowsRowIdGet(requestParameters.rateTableId, requestParameters.rowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Rate Table Rows
     * @param {RateTablesApiGetRateTableRowsRatesRateTablesRateTableIdRowsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.getRateTableRowsRatesRateTablesRateTableIdRowsGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).getRateTableRowsRatesRateTablesRateTableIdRowsGet(requestParameters.rateTableId, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Rate Table
     * @param {RateTablesApiUpdateRateTableRatesRateTablesRateTableIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.updateRateTableRatesRateTablesRateTableIdPut = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).updateRateTableRatesRateTablesRateTableIdPut(requestParameters.rateTableId, requestParameters.updateRateTable, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RateTablesApi;
}(base_1.BaseAPI));
exports.RateTablesApi = RateTablesApi;
/**
 * RatingApi - axios parameter creator
 * @export
 */
var RatingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create Ftl Rate Request
         * @param {CreateFtlRateRequest} createFtlRateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFtlRateRequestRatesFtlPost: function (createFtlRateRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createFtlRateRequest_1], args_1, true), void 0, function (createFtlRateRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createFtlRateRequest' is not null or undefined
                            (0, common_1.assertParamExists)('createFtlRateRequestRatesFtlPost', 'createFtlRateRequest', createFtlRateRequest);
                            localVarPath = "/rates/ftl";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createFtlRateRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Rate Failures
         * @param {string} rateRequestId
         * @param {CreateRateRequestFailure} createRateRequestFailure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateFailuresRatesRateRequestIdFailuresPost: function (rateRequestId_1, createRateRequestFailure_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1, createRateRequestFailure_1], args_1, true), void 0, function (rateRequestId, createRateRequestFailure, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('createRateFailuresRatesRateRequestIdFailuresPost', 'rateRequestId', rateRequestId);
                            // verify required parameter 'createRateRequestFailure' is not null or undefined
                            (0, common_1.assertParamExists)('createRateFailuresRatesRateRequestIdFailuresPost', 'createRateRequestFailure', createRateRequestFailure);
                            localVarPath = "/rates/{rate_request_id}/failures"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createRateRequestFailure, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates new rate request.
         * @param {CreateParcelRateRequest} createParcelRateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateRequest: function (createParcelRateRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createParcelRateRequest_1], args_1, true), void 0, function (createParcelRateRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createParcelRateRequest' is not null or undefined
                            (0, common_1.assertParamExists)('createRateRequest', 'createParcelRateRequest', createParcelRateRequest);
                            localVarPath = "/rate-requests-details";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createParcelRateRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return dispatches by rate-request-id.
         * @summary Get Dispatches By Rate Request Id
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispatchesByRateRequestIdRateRequestsRateRequestIdDispatchesGet: function (rateRequestId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1], args_1, true), void 0, function (rateRequestId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getDispatchesByRateRequestIdRateRequestsRateRequestIdDispatchesGet', 'rateRequestId', rateRequestId);
                            localVarPath = "/rate-requests/{rate_request_id}/dispatches"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns specific rate belonging to a rate request.
         * @param {string} rateRequestId
         * @param {string} rateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateByRateId: function (rateRequestId_1, rateId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1, rateId_1], args_1, true), void 0, function (rateRequestId, rateId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateByRateId', 'rateRequestId', rateRequestId);
                            // verify required parameter 'rateId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateByRateId', 'rateId', rateId);
                            localVarPath = "/rate-requests-details/{rate_request_id}/rates/{rate_id}"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)))
                                .replace("{".concat("rate_id", "}"), encodeURIComponent(String(rateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}/failures\' but with more suitable URL.
         * @summary Get Rate Failures
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateFailuresRateRequestsRateRequestIdFailuresGet: function (rateRequestId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1], args_1, true), void 0, function (rateRequestId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateFailuresRateRequestsRateRequestIdFailuresGet', 'rateRequestId', rateRequestId);
                            localVarPath = "/rate-requests/{rate_request_id}/failures"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rate Failures
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateFailuresRatesRateRequestIdFailuresGet: function (rateRequestId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1], args_1, true), void 0, function (rateRequestId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateFailuresRatesRateRequestIdFailuresGet', 'rateRequestId', rateRequestId);
                            localVarPath = "/rates/{rate_request_id}/failures"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rate Quotes
         * @param {RateRequest} rateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateQuotesRatingQuotePost: function (rateRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequest_1], args_1, true), void 0, function (rateRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequest' is not null or undefined
                            (0, common_1.assertParamExists)('getRateQuotesRatingQuotePost', 'rateRequest', rateRequest);
                            localVarPath = "/rating/quote";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rateRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}/{rate_id}\' but with more suitable URL.
         * @summary Get Rate
         * @param {string} rateRequestId
         * @param {string} rateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRateRequestsRateRequestIdRatesRateIdGet: function (rateRequestId_1, rateId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1, rateId_1], args_1, true), void 0, function (rateRequestId, rateId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateRateRequestsRateRequestIdRatesRateIdGet', 'rateRequestId', rateRequestId);
                            // verify required parameter 'rateId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateRateRequestsRateRequestIdRatesRateIdGet', 'rateId', rateId);
                            localVarPath = "/rate-requests/{rate_request_id}/rates/{rate_id}"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)))
                                .replace("{".concat("rate_id", "}"), encodeURIComponent(String(rateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rate
         * @param {string} rateRequestId
         * @param {string} rateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRatesRateRequestIdRateIdGet: function (rateRequestId_1, rateId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1, rateId_1], args_1, true), void 0, function (rateRequestId, rateId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateRatesRateRequestIdRateIdGet', 'rateRequestId', rateRequestId);
                            // verify required parameter 'rateId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateRatesRateRequestIdRateIdGet', 'rateId', rateId);
                            localVarPath = "/rates/{rate_request_id}/{rate_id}"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)))
                                .replace("{".concat("rate_id", "}"), encodeURIComponent(String(rateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns single rate request for given id.
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRequestByRequestId: function (rateRequestId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1], args_1, true), void 0, function (rateRequestId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateRequestByRequestId', 'rateRequestId', rateRequestId);
                            localVarPath = "/rate-requests-details/{rate_request_id}"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returning rate-request data and additional \'include\' fields. Available \'include\' query values: [\'failures\', \'dispatches\']
         * @param {string} rateRequestId
         * @param {Array<string>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRequestDispatchesRateRequestsRateRequestIdGet: function (rateRequestId_1, include_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1, include_1], args_1, true), void 0, function (rateRequestId, include, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getRateRequestDispatchesRateRequestsRateRequestIdGet', 'rateRequestId', rateRequestId);
                            localVarPath = "/rate-requests/{rate_request_id}"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}\' but with more suitable URL.
         * @summary Get Rates
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesRateRequestsRateRequestIdRatesGet: function (rateRequestId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1], args_1, true), void 0, function (rateRequestId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getRatesRateRequestsRateRequestIdRatesGet', 'rateRequestId', rateRequestId);
                            localVarPath = "/rate-requests/{rate_request_id}/rates"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rates
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesRatesRateRequestIdGet: function (rateRequestId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1], args_1, true), void 0, function (rateRequestId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('getRatesRatesRateRequestIdGet', 'rateRequestId', rateRequestId);
                            localVarPath = "/rates/{rate_request_id}"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns list of rate requests belonging to tenant.
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [shipmentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRateRequests: function (page_1, limit_1, shipmentId_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, limit_1, shipmentId_1], args_1, true), void 0, function (page, limit, shipmentId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/rate-requests-details";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns list of rates for a given rate request.
         * @param {string} rateRequestId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRatesByRequestId: function (rateRequestId_1, page_1, limit_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1, page_1, limit_1], args_1, true), void 0, function (rateRequestId, page, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('listRatesByRequestId', 'rateRequestId', rateRequestId);
                            localVarPath = "/rate-requests-details/{rate_request_id}/rates"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Rate
         * @param {string} rateRequestId
         * @param {string} rateId
         * @param {Rate1} rate1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRateRatesRateRequestIdRateIdPost: function (rateRequestId_1, rateId_1, rate1_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1, rateId_1, rate1_1], args_1, true), void 0, function (rateRequestId, rateId, rate1, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('postRateRatesRateRequestIdRateIdPost', 'rateRequestId', rateRequestId);
                            // verify required parameter 'rateId' is not null or undefined
                            (0, common_1.assertParamExists)('postRateRatesRateRequestIdRateIdPost', 'rateId', rateId);
                            // verify required parameter 'rate1' is not null or undefined
                            (0, common_1.assertParamExists)('postRateRatesRateRequestIdRateIdPost', 'rate1', rate1);
                            localVarPath = "/rates/{rate_request_id}/{rate_id}"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)))
                                .replace("{".concat("rate_id", "}"), encodeURIComponent(String(rateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rate1, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an existing rate and it\'s child resources, i.e. carrier, accessorials, items, stops, etc.
         * @param {string} rateRequestId Should be the identifier from the original request for rates, request.
         * @param {string} id Rate id provided when creating a new rate with the post method on this route
         * @param {FtlRate} ftlRate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRateRatesRateRequestIdIdPut: function (rateRequestId_1, id_1, ftlRate_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([rateRequestId_1, id_1, ftlRate_1], args_1, true), void 0, function (rateRequestId, id, ftlRate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rateRequestId' is not null or undefined
                            (0, common_1.assertParamExists)('putRateRatesRateRequestIdIdPut', 'rateRequestId', rateRequestId);
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('putRateRatesRateRequestIdIdPut', 'id', id);
                            // verify required parameter 'ftlRate' is not null or undefined
                            (0, common_1.assertParamExists)('putRateRatesRateRequestIdIdPut', 'ftlRate', ftlRate);
                            localVarPath = "/rates/{rate_request_id}/{id}"
                                .replace("{".concat("rate_request_id", "}"), encodeURIComponent(String(rateRequestId)))
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ftlRate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RatingApiAxiosParamCreator = RatingApiAxiosParamCreator;
/**
 * RatingApi - functional programming interface
 * @export
 */
var RatingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RatingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create Ftl Rate Request
         * @param {CreateFtlRateRequest} createFtlRateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFtlRateRequestRatesFtlPost: function (createFtlRateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createFtlRateRequestRatesFtlPost(createFtlRateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.createFtlRateRequestRatesFtlPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Rate Failures
         * @param {string} rateRequestId
         * @param {CreateRateRequestFailure} createRateRequestFailure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateFailuresRatesRateRequestIdFailuresPost: function (rateRequestId, createRateRequestFailure, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRateFailuresRatesRateRequestIdFailuresPost(rateRequestId, createRateRequestFailure, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.createRateFailuresRatesRateRequestIdFailuresPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates new rate request.
         * @param {CreateParcelRateRequest} createParcelRateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateRequest: function (createParcelRateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRateRequest(createParcelRateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.createRateRequest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return dispatches by rate-request-id.
         * @summary Get Dispatches By Rate Request Id
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispatchesByRateRequestIdRateRequestsRateRequestIdDispatchesGet: function (rateRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDispatchesByRateRequestIdRateRequestsRateRequestIdDispatchesGet(rateRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.getDispatchesByRateRequestIdRateRequestsRateRequestIdDispatchesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns specific rate belonging to a rate request.
         * @param {string} rateRequestId
         * @param {string} rateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateByRateId: function (rateRequestId, rateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateByRateId(rateRequestId, rateId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.getRateByRateId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}/failures\' but with more suitable URL.
         * @summary Get Rate Failures
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateFailuresRateRequestsRateRequestIdFailuresGet: function (rateRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateFailuresRateRequestsRateRequestIdFailuresGet(rateRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.getRateFailuresRateRequestsRateRequestIdFailuresGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rate Failures
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateFailuresRatesRateRequestIdFailuresGet: function (rateRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateFailuresRatesRateRequestIdFailuresGet(rateRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.getRateFailuresRatesRateRequestIdFailuresGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rate Quotes
         * @param {RateRequest} rateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateQuotesRatingQuotePost: function (rateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateQuotesRatingQuotePost(rateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.getRateQuotesRatingQuotePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}/{rate_id}\' but with more suitable URL.
         * @summary Get Rate
         * @param {string} rateRequestId
         * @param {string} rateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRateRequestsRateRequestIdRatesRateIdGet: function (rateRequestId, rateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateRateRequestsRateRequestIdRatesRateIdGet(rateRequestId, rateId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.getRateRateRequestsRateRequestIdRatesRateIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rate
         * @param {string} rateRequestId
         * @param {string} rateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRatesRateRequestIdRateIdGet: function (rateRequestId, rateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateRatesRateRequestIdRateIdGet(rateRequestId, rateId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.getRateRatesRateRequestIdRateIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns single rate request for given id.
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRequestByRequestId: function (rateRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateRequestByRequestId(rateRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.getRateRequestByRequestId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returning rate-request data and additional \'include\' fields. Available \'include\' query values: [\'failures\', \'dispatches\']
         * @param {string} rateRequestId
         * @param {Array<string>} [include]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRequestDispatchesRateRequestsRateRequestIdGet: function (rateRequestId, include, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRateRequestDispatchesRateRequestsRateRequestIdGet(rateRequestId, include, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.getRateRequestDispatchesRateRequestsRateRequestIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}\' but with more suitable URL.
         * @summary Get Rates
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesRateRequestsRateRequestIdRatesGet: function (rateRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRatesRateRequestsRateRequestIdRatesGet(rateRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.getRatesRateRequestsRateRequestIdRatesGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Rates
         * @param {string} rateRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesRatesRateRequestIdGet: function (rateRequestId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRatesRatesRateRequestIdGet(rateRequestId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.getRatesRatesRateRequestIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns list of rate requests belonging to tenant.
         * @param {number} [page]
         * @param {number} [limit]
         * @param {string} [shipmentId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRateRequests: function (page, limit, shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listRateRequests(page, limit, shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.listRateRequests']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns list of rates for a given rate request.
         * @param {string} rateRequestId
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRatesByRequestId: function (rateRequestId, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listRatesByRequestId(rateRequestId, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.listRatesByRequestId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Post Rate
         * @param {string} rateRequestId
         * @param {string} rateId
         * @param {Rate1} rate1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRateRatesRateRequestIdRateIdPost: function (rateRequestId, rateId, rate1, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.postRateRatesRateRequestIdRateIdPost(rateRequestId, rateId, rate1, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.postRateRatesRateRequestIdRateIdPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an existing rate and it\'s child resources, i.e. carrier, accessorials, items, stops, etc.
         * @param {string} rateRequestId Should be the identifier from the original request for rates, request.
         * @param {string} id Rate id provided when creating a new rate with the post method on this route
         * @param {FtlRate} ftlRate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRateRatesRateRequestIdIdPut: function (rateRequestId, id, ftlRate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putRateRatesRateRequestIdIdPut(rateRequestId, id, ftlRate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RatingApi.putRateRatesRateRequestIdIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RatingApiFp = RatingApiFp;
/**
 * RatingApi - factory interface
 * @export
 */
var RatingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RatingApiFp)(configuration);
    return {
        /**
         *
         * @summary Create Ftl Rate Request
         * @param {RatingApiCreateFtlRateRequestRatesFtlPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFtlRateRequestRatesFtlPost: function (requestParameters, options) {
            return localVarFp.createFtlRateRequestRatesFtlPost(requestParameters.createFtlRateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Rate Failures
         * @param {RatingApiCreateRateFailuresRatesRateRequestIdFailuresPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateFailuresRatesRateRequestIdFailuresPost: function (requestParameters, options) {
            return localVarFp.createRateFailuresRatesRateRequestIdFailuresPost(requestParameters.rateRequestId, requestParameters.createRateRequestFailure, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates new rate request.
         * @param {RatingApiCreateRateRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRateRequest: function (requestParameters, options) {
            return localVarFp.createRateRequest(requestParameters.createParcelRateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return dispatches by rate-request-id.
         * @summary Get Dispatches By Rate Request Id
         * @param {RatingApiGetDispatchesByRateRequestIdRateRequestsRateRequestIdDispatchesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDispatchesByRateRequestIdRateRequestsRateRequestIdDispatchesGet: function (requestParameters, options) {
            return localVarFp.getDispatchesByRateRequestIdRateRequestsRateRequestIdDispatchesGet(requestParameters.rateRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns specific rate belonging to a rate request.
         * @param {RatingApiGetRateByRateIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateByRateId: function (requestParameters, options) {
            return localVarFp.getRateByRateId(requestParameters.rateRequestId, requestParameters.rateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}/failures\' but with more suitable URL.
         * @summary Get Rate Failures
         * @param {RatingApiGetRateFailuresRateRequestsRateRequestIdFailuresGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateFailuresRateRequestsRateRequestIdFailuresGet: function (requestParameters, options) {
            return localVarFp.getRateFailuresRateRequestsRateRequestIdFailuresGet(requestParameters.rateRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Rate Failures
         * @param {RatingApiGetRateFailuresRatesRateRequestIdFailuresGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateFailuresRatesRateRequestIdFailuresGet: function (requestParameters, options) {
            return localVarFp.getRateFailuresRatesRateRequestIdFailuresGet(requestParameters.rateRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Rate Quotes
         * @param {RatingApiGetRateQuotesRatingQuotePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateQuotesRatingQuotePost: function (requestParameters, options) {
            return localVarFp.getRateQuotesRatingQuotePost(requestParameters.rateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}/{rate_id}\' but with more suitable URL.
         * @summary Get Rate
         * @param {RatingApiGetRateRateRequestsRateRequestIdRatesRateIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRateRequestsRateRequestIdRatesRateIdGet: function (requestParameters, options) {
            return localVarFp.getRateRateRequestsRateRequestIdRatesRateIdGet(requestParameters.rateRequestId, requestParameters.rateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Rate
         * @param {RatingApiGetRateRatesRateRequestIdRateIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRatesRateRequestIdRateIdGet: function (requestParameters, options) {
            return localVarFp.getRateRatesRateRequestIdRateIdGet(requestParameters.rateRequestId, requestParameters.rateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns single rate request for given id.
         * @param {RatingApiGetRateRequestByRequestIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRequestByRequestId: function (requestParameters, options) {
            return localVarFp.getRateRequestByRequestId(requestParameters.rateRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returning rate-request data and additional \'include\' fields. Available \'include\' query values: [\'failures\', \'dispatches\']
         * @param {RatingApiGetRateRequestDispatchesRateRequestsRateRequestIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateRequestDispatchesRateRequestsRateRequestIdGet: function (requestParameters, options) {
            return localVarFp.getRateRequestDispatchesRateRequestsRateRequestIdGet(requestParameters.rateRequestId, requestParameters.include, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * The same route as the \'/rates/{rate_request_id}\' but with more suitable URL.
         * @summary Get Rates
         * @param {RatingApiGetRatesRateRequestsRateRequestIdRatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesRateRequestsRateRequestIdRatesGet: function (requestParameters, options) {
            return localVarFp.getRatesRateRequestsRateRequestIdRatesGet(requestParameters.rateRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Rates
         * @param {RatingApiGetRatesRatesRateRequestIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatesRatesRateRequestIdGet: function (requestParameters, options) {
            return localVarFp.getRatesRatesRateRequestIdGet(requestParameters.rateRequestId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns list of rate requests belonging to tenant.
         * @param {RatingApiListRateRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRateRequests: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.listRateRequests(requestParameters.page, requestParameters.limit, requestParameters.shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns list of rates for a given rate request.
         * @param {RatingApiListRatesByRequestIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRatesByRequestId: function (requestParameters, options) {
            return localVarFp.listRatesByRequestId(requestParameters.rateRequestId, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post Rate
         * @param {RatingApiPostRateRatesRateRequestIdRateIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRateRatesRateRequestIdRateIdPost: function (requestParameters, options) {
            return localVarFp.postRateRatesRateRequestIdRateIdPost(requestParameters.rateRequestId, requestParameters.rateId, requestParameters.rate1, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an existing rate and it\'s child resources, i.e. carrier, accessorials, items, stops, etc.
         * @param {RatingApiPutRateRatesRateRequestIdIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRateRatesRateRequestIdIdPut: function (requestParameters, options) {
            return localVarFp.putRateRatesRateRequestIdIdPut(requestParameters.rateRequestId, requestParameters.id, requestParameters.ftlRate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RatingApiFactory = RatingApiFactory;
/**
 * RatingApi - object-oriented interface
 * @export
 * @class RatingApi
 * @extends {BaseAPI}
 */
var RatingApi = /** @class */ (function (_super) {
    __extends(RatingApi, _super);
    function RatingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create Ftl Rate Request
     * @param {RatingApiCreateFtlRateRequestRatesFtlPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.createFtlRateRequestRatesFtlPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).createFtlRateRequestRatesFtlPost(requestParameters.createFtlRateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Rate Failures
     * @param {RatingApiCreateRateFailuresRatesRateRequestIdFailuresPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.createRateFailuresRatesRateRequestIdFailuresPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).createRateFailuresRatesRateRequestIdFailuresPost(requestParameters.rateRequestId, requestParameters.createRateRequestFailure, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates new rate request.
     * @param {RatingApiCreateRateRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.createRateRequest = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).createRateRequest(requestParameters.createParcelRateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return dispatches by rate-request-id.
     * @summary Get Dispatches By Rate Request Id
     * @param {RatingApiGetDispatchesByRateRequestIdRateRequestsRateRequestIdDispatchesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.getDispatchesByRateRequestIdRateRequestsRateRequestIdDispatchesGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).getDispatchesByRateRequestIdRateRequestsRateRequestIdDispatchesGet(requestParameters.rateRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns specific rate belonging to a rate request.
     * @param {RatingApiGetRateByRateIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.getRateByRateId = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).getRateByRateId(requestParameters.rateRequestId, requestParameters.rateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * The same route as the \'/rates/{rate_request_id}/failures\' but with more suitable URL.
     * @summary Get Rate Failures
     * @param {RatingApiGetRateFailuresRateRequestsRateRequestIdFailuresGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.getRateFailuresRateRequestsRateRequestIdFailuresGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).getRateFailuresRateRequestsRateRequestIdFailuresGet(requestParameters.rateRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Rate Failures
     * @param {RatingApiGetRateFailuresRatesRateRequestIdFailuresGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.getRateFailuresRatesRateRequestIdFailuresGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).getRateFailuresRatesRateRequestIdFailuresGet(requestParameters.rateRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Rate Quotes
     * @param {RatingApiGetRateQuotesRatingQuotePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.getRateQuotesRatingQuotePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).getRateQuotesRatingQuotePost(requestParameters.rateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * The same route as the \'/rates/{rate_request_id}/{rate_id}\' but with more suitable URL.
     * @summary Get Rate
     * @param {RatingApiGetRateRateRequestsRateRequestIdRatesRateIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.getRateRateRequestsRateRequestIdRatesRateIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).getRateRateRequestsRateRequestIdRatesRateIdGet(requestParameters.rateRequestId, requestParameters.rateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Rate
     * @param {RatingApiGetRateRatesRateRequestIdRateIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.getRateRatesRateRequestIdRateIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).getRateRatesRateRequestIdRateIdGet(requestParameters.rateRequestId, requestParameters.rateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns single rate request for given id.
     * @param {RatingApiGetRateRequestByRequestIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.getRateRequestByRequestId = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).getRateRequestByRequestId(requestParameters.rateRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returning rate-request data and additional \'include\' fields. Available \'include\' query values: [\'failures\', \'dispatches\']
     * @param {RatingApiGetRateRequestDispatchesRateRequestsRateRequestIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.getRateRequestDispatchesRateRequestsRateRequestIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).getRateRequestDispatchesRateRequestsRateRequestIdGet(requestParameters.rateRequestId, requestParameters.include, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * The same route as the \'/rates/{rate_request_id}\' but with more suitable URL.
     * @summary Get Rates
     * @param {RatingApiGetRatesRateRequestsRateRequestIdRatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.getRatesRateRequestsRateRequestIdRatesGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).getRatesRateRequestsRateRequestIdRatesGet(requestParameters.rateRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Rates
     * @param {RatingApiGetRatesRatesRateRequestIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.getRatesRatesRateRequestIdGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).getRatesRatesRateRequestIdGet(requestParameters.rateRequestId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns list of rate requests belonging to tenant.
     * @param {RatingApiListRateRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.listRateRequests = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.RatingApiFp)(this.configuration).listRateRequests(requestParameters.page, requestParameters.limit, requestParameters.shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns list of rates for a given rate request.
     * @param {RatingApiListRatesByRequestIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.listRatesByRequestId = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).listRatesByRequestId(requestParameters.rateRequestId, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post Rate
     * @param {RatingApiPostRateRatesRateRequestIdRateIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.postRateRatesRateRequestIdRateIdPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).postRateRatesRateRequestIdRateIdPost(requestParameters.rateRequestId, requestParameters.rateId, requestParameters.rate1, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an existing rate and it\'s child resources, i.e. carrier, accessorials, items, stops, etc.
     * @param {RatingApiPutRateRatesRateRequestIdIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatingApi
     */
    RatingApi.prototype.putRateRatesRateRequestIdIdPut = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RatingApiFp)(this.configuration).putRateRatesRateRequestIdIdPut(requestParameters.rateRequestId, requestParameters.id, requestParameters.ftlRate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RatingApi;
}(base_1.BaseAPI));
exports.RatingApi = RatingApi;
/**
 * SMC3Api - axios parameter creator
 * @export
 */
var SMC3ApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get SMC3 Rate for linehaul
         * @param {Smc3RateQuery} smc3RateQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmc3LineHaulRateProvidersSMC3LinehaulPost: function (smc3RateQuery_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([smc3RateQuery_1], args_1, true), void 0, function (smc3RateQuery, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'smc3RateQuery' is not null or undefined
                            (0, common_1.assertParamExists)('getSmc3LineHaulRateProvidersSMC3LinehaulPost', 'smc3RateQuery', smc3RateQuery);
                            localVarPath = "/providers/SMC3/linehaul";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(smc3RateQuery, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SMC3ApiAxiosParamCreator = SMC3ApiAxiosParamCreator;
/**
 * SMC3Api - functional programming interface
 * @export
 */
var SMC3ApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SMC3ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get SMC3 Rate for linehaul
         * @param {Smc3RateQuery} smc3RateQuery
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmc3LineHaulRateProvidersSMC3LinehaulPost: function (smc3RateQuery, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSmc3LineHaulRateProvidersSMC3LinehaulPost(smc3RateQuery, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SMC3Api.getSmc3LineHaulRateProvidersSMC3LinehaulPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SMC3ApiFp = SMC3ApiFp;
/**
 * SMC3Api - factory interface
 * @export
 */
var SMC3ApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SMC3ApiFp)(configuration);
    return {
        /**
         *
         * @summary Get SMC3 Rate for linehaul
         * @param {SMC3ApiGetSmc3LineHaulRateProvidersSMC3LinehaulPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmc3LineHaulRateProvidersSMC3LinehaulPost: function (requestParameters, options) {
            return localVarFp.getSmc3LineHaulRateProvidersSMC3LinehaulPost(requestParameters.smc3RateQuery, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SMC3ApiFactory = SMC3ApiFactory;
/**
 * SMC3Api - object-oriented interface
 * @export
 * @class SMC3Api
 * @extends {BaseAPI}
 */
var SMC3Api = /** @class */ (function (_super) {
    __extends(SMC3Api, _super);
    function SMC3Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get SMC3 Rate for linehaul
     * @param {SMC3ApiGetSmc3LineHaulRateProvidersSMC3LinehaulPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SMC3Api
     */
    SMC3Api.prototype.getSmc3LineHaulRateProvidersSMC3LinehaulPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SMC3ApiFp)(this.configuration).getSmc3LineHaulRateProvidersSMC3LinehaulPost(requestParameters.smc3RateQuery, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SMC3Api;
}(base_1.BaseAPI));
exports.SMC3Api = SMC3Api;
